/* ==========================================================================
   DRYSNAKE — Chatbot du site web (fichier assemblé, ne pas modifier à la main)
   Assemblé le 2026-08-20 à partir de : src/drysnake-kb.js, src/journal.js, src/memoire.js, src/ia.js, src/drysnake-engine.js, src/drysnake-widget.js
   Pour changer une réponse : modifier src/drysnake-kb.js puis relancer « node build.js ».
   ========================================================================== */

/* ---------- drysnake-kb.js ---------- */
/* ============================================================================
   DRYSNAKE — Base de connaissances du chatbot
   ----------------------------------------------------------------------------
   Construite à partir de 379 vraies conversations clients (nov. 2023 – août 2026)
   + du catalogue et des politiques en direct de drysnake.com.

   POUR MODIFIER UNE RÉPONSE : trouvez l'entrée, changez le texte de "fr" ou "en".
   Mise en forme permise dans les réponses :
      **gras**            -> texte en gras
      [texte](/chemin)    -> lien vers drysnake.com (le /fr/ est ajouté tout seul)
      - début de ligne    -> puce
      saut de ligne       -> nouvelle ligne
   ========================================================================== */

window.DRYSNAKE_KB = {

  /* Mots équivalents : la clé de gauche est le mot « officiel »,
     tout ce qui est à droite y est ramené (français, anglais, fautes, argot). */
  synonyms: {
    sac:        ['bag','bags','poche','poches','sacoche','sacs','valise'],
    ventilateur:['fan','fans','ventilo','ventilateurs','souffleur','blower','moteur'],
    alimentation:['adaptateur','bloc','chargeur','charger','adapter','plug','cord','cordon','fil','wire','power','supply','transformateur','brique','outlet'],
    secher:     ['sechage','dry','drying','dries','seche','asseche','sec','dried'],
    odeur:      ['odor','odour','smell','smelly','stink','stinks','puant','senteur','pue','parfum','scent','bacteria','bacterie','moisissure','mold'],
    cartouche:  ['cartridge','cartridges','cartouches','freshplex','desodorisant','desodorisante','desodorisantes','deodorizing','deodorizer','deodorant','pastille'],
    garantie:   ['warranty','guarantee','garanti','garantis','couvert','covered','coverage'],
    retour:     ['return','returns','retourner','renvoyer','retours','rma'],
    remboursement:['refund','refunds','rembourser','rembourse','reimbursement'],
    livraison:  ['shipping','ship','ships','shipped','delivery','deliver','delivered','expedition','expedie','envoi','poste','shipment','livrer','livre','transport','recevoir','recois','recoit','recu','recue','recevrai','receive','received','receiving'],
    delai:      ['delay','delais','temps','time','long','longtemps','duree','when','quand','rapidite','vite','fast','quickly','jour','jours','journee','day','days','semaine','semaines','week','weeks','ouvrable','ouvrables'],
    prix:       ['price','prices','cost','costs','couts','cout','coute','tarif','montant','cher','expensive','much'],
    rabais:     ['discount','promo','promotion','coupon','code','solde','sale','deal','special','aubaine','vendredifou','blackfriday'],
    taille:     ['size','sizes','grandeur','format','fit','fits','mesurer','large','small'],
    dimension:  ['dimensions','mesure','mesures','measurement','measurements','specs','fiche','pouces','inches','longueur','largeur','hauteur','poids','weight','capacite','capacity','litre','litres','liters','volume'],
    junior:     ['jr','enfant','enfants','kid','kids','child','children','petit','ado','teen','fils','fille','daughter'],
    adulte:     ['adult','adultes','xl','grand','senior'],
    gardien:    ['goalie','goaltender','goal','keeper','gardiens','jambieres','pads'],
    joueur:     ['player','players','joueurs','skater'],
    roues:      ['wheel','wheels','roue','roulettes','rolling','wheelie','roulette'],
    commande:   ['order','orders','commandes','achat','purchase','panier','cart','checkout','facture','invoice'],
    suivi:      ['tracking','track','trace','status','statut','colis','package','parcel'],
    taxes:      ['tax','taxe','tps','tvq','gst','qst','hst','vat','duty','duties','douane','customs','tariff','tariffs','import','frontiere','border'],
    laver:      ['wash','washing','washer','laveuse','lavage','nettoyer','nettoyage','clean','cleaning','entretien'],
    reparation: ['repair','repairs','reparer','fix','fixed','broken','brise','bris','briser','defectueux','defect','damaged','endommage','dechire','decousu','couture','seam','stitching','defaire','defait','decoudre','effiloche','fraying','frayed','trou','hole','fissure','craque','usure','usee','arrache'],
    zip:        ['zipper','zippers','fermeture','eclair','glissiere','zips'],
    couleur:    ['color','colors','colour','colours','couleurs','noir','black','navy','marine','rouge','red','bleu','blue','royal'],
    gratuit:    ['gratuite','gratuits','free','offert','offerte','frais'],
    perdu:      ['lost','vole','volee','stolen','egare','disparu','jamais'],
    international:['etranger','monde','worldwide','overseas','mondial'],
    avis:       ['review','reviews','temoignage','temoignages','testimonial','commentaire','commentaires','preuve','proof','fiable','reputation'],
    bacterie:   ['bacteries','bacteria','moisissure','moisissures','mold','mildew','microbe','microbes','champignon'],
    stock:      ['inventaire','inventory','disponible','disponibilite','available','availability','rupture','soldout','reapprovisionnement','restock'],
    equipe:     ['team','teams','club','equipes','association','logo','broderie','embroidery','personnalise','personnalisation','custom','wholesale','gros','revendeur','dealer','distributeur','quantite'],
    boutique:   ['store','magasin','showroom','physique','physical','ramassage','pickup','cueillette','adresse','address','usine','entrepot','warehouse','gatineau','local'],
    contact:    ['humain','human','agent','parler','talk','speak','someone','quelquun','personne','telephone','phone','courriel','email','joindre','service','support','conseiller'],
    bruit:      ['noise','noisy','loud','sonore','decibel','decibels','fort','silencieux','quiet'],
    electricite:['electricity','watt','watts','hydro','consommation','energie','energy','bill','voltage','volts'],
    auto:       ['car','voiture','vehicle','vehicule','camion','truck','allumecigare','lighter','12v','portable','batterie','battery','powerbank','arena','vestiaire','casier','locker','tournoi','tournament','voyage','travel'],
    inclus:     ['included','include','includes','comprend','contient','boite','box','fourni','livreavec','comeswith'],
    difference: ['different','differences','vs','versus','compare','comparaison','comparison','entre','between','lequel','which','choisir','choose','choix','recommandez','recommend'],
    echange:    ['exchange','exchanges','echanger','changer','change','swap','modifier'],
    adresse:    ['address','adresses'],
    annuler:    ['cancel','cancellation','annulation','annule'],
    cadeau:     ['gift','gifts','present','cadeaux','giftcard','noel','christmas','anniversaire','birthday','fete'],
    structure:  ['tube','tubes','tuyau','tuyaux','rod','rods','tige','tiges','systeme','system','armature','coque','shell'],
    rangement:  ['storage','ranger','entreposer','entreposage','ete','summer','offseason','hiver','winter'],
    fonctionne: ['fonctionnement','works','working','probleme','problem','issue','marche','panne','allume','demarre','start','starts'],
    autresport: ['ringuette','ringette','football','lacrosse','baseball','soccer','dek','deck','balle','patinartistique','figureskating','sport','sports','gym'],
    materiel:   ['tissu','fabric','material','solide','solidite','resistant','resistance','durable','durabilite','qualite','quality','fabrique','made','canada']
  },

  /* Mots ignorés dans l'analyse de la question. */
  stopwords: ['le','la','les','un','une','des','du','de','au','aux','et','ou','a','en','pour','par','avec','sans','sur','dans','que','qui','quoi','est','sont','ce','cette','ces','mon','ma','mes','votre','vos','nos','notre','je','tu','il','elle','on','nous','vous','ils','elles','se','sa','son','leur','ne','pas','tres','bien','tout','tous','toute','toutes','me','te','lui','dont','si','comme','mais','donc','car','alors','aussi','deja','faire','avoir','etre','ai','as','ont','avez','avons','peut','peux','pouvez','veux','veut','voulez','dois','doit','the','an','of','to','in','on','for','with','and','or','is','are','was','were','be','been','it','this','that','these','those','my','your','our','their','i','you','he','she','we','they','do','does','did','can','could','would','should','will','shall','have','has','had','get','got','him','her','us','them','at','by','from','as','so','but','not','no','yes','please','hi','hello','there','im','ive','id','its','about','any','some','what','which','who','whom','whose','how','when','where','why','s','t','y','d','l','n','qu','est-ce','bonjour','allo','salut','merci','svp','stp','use','used','using','utiliser','utilise','utilisation','want','wants','wanted','need','needs','like','likes','liked','aime','aimerais','voudrais','wondering','question','questions','info','information','pls','ok','oui','non','just','really','also','more','fait','vaut','valoir','peine','monter','savoir','dire','voudrais','jaimerais','aimerais','wondering','stuff','quick','aujourdhui','hier','demain','ca','sa','prend','prendre','pris','va','vais','vont','allez','faut','arrive','combien','sais','sait','dire','dit','vraiment','environ','peu','beaucoup','autre','autres','meme','chaque','toute','celui','celle','ceux'],

  /* Questions proposées à l'ouverture du chat. */
  suggestions: {
    fr: ['Différence entre le PRO et le DELUXE ?','Quelle grandeur choisir ?','Combien de temps pour sécher ?','C\'est quoi la garantie ?','Délais de livraison ?','Mon ventilateur ne fonctionne pas'],
    en: ['Difference between PRO and DELUXE?','Which size should I choose?','How long does it take to dry?','What is the warranty?','Shipping times?','My fan is not working']
  },

  /* ==========================================================================
     LES RÉPONSES
     ========================================================================== */
  entries: [

  /* ---------- PRODUITS / CHOIX ---------- */
  {
    id: 'pro-vs-deluxe',
    title: { fr: 'Différence PRO / DELUXE', en: 'PRO vs DELUXE' },
    tags: ['difference','pro','deluxe','modele','sac','choisir','comparer'],
    q: {
      fr: ['quelle est la difference entre le pro et le deluxe','pro ou deluxe','comparer les modeles','lequel choisir pro deluxe','difference entre les sacs','quel modele prendre'],
      en: ['what is the difference between the pro and the deluxe','pro vs deluxe','compare models','which model should i choose','difference between the bags']
    },
    a: {
      fr: "Même système de séchage dans les deux, seul le rangement change.\n**PRO** : une grande ouverture, une pochette filet. Simple et le plus spacieux.\n**DELUXE** : poches sur les quatre côtés et section isolée pour les patins (ventilée elle aussi). [Comparer](/collections/all)",
      en: "Same drying system in both — only the storage differs.\n**PRO**: one large opening, one mesh pocket. Simple and the roomiest.\n**DELUXE**: pockets on all four sides plus an insulated skate section (also ventilated). [Compare](/collections/all)"
    }
  },
  {
    id: 'taille',
    title: { fr: 'Quelle grandeur choisir', en: 'Choosing the right size' },
    tags: ['taille','grandeur','junior','adulte','choisir','sac'],
    q: {
      fr: ['quelle grandeur choisir','junior ou adulte','quelle taille de sac','mon fils mesure 5 pieds 8','quelle grandeur pour un ado','est ce que le junior est assez grand'],
      en: ['which size should i choose','junior or adult','what size bag do i need','how do i know what size','will it fit my gear','is the junior big enough']
    },
    a: {
      fr: "**DELUXE Junior** : équipement jusqu'à Medium (un Medium adulte entre, mais serré).\n**DELUXE Adulte** : équipement Medium adulte ou plus grand.\n**PRO** : une seule grandeur, convient à tous. En cas de doute, prenez plus grand.",
      en: "**DELUXE Junior**: gear up to Medium (an adult Medium fits, but tightly).\n**DELUXE Adult**: adult Medium gear or larger.\n**PRO**: one size, fits everyone. When in doubt, size up."
    }
  },
  {
    id: 'gardien',
    title: { fr: 'Le sac de gardien', en: 'The goalie bag' },
    tags: ['gardien','sac','modele','jambieres'],
    q: {
      fr: ['avez vous un sac pour gardien','sac de gardien de but','est ce que les jambieres rentrent','sac goalie'],
      en: ['do you have a goalie bag','bag for goaltender','do leg pads fit','goalie model']
    },
    a: {
      fr: "Oui : le **PRO pour gardien**, 42 x 16 x 18 po, avec un ventilateur plus puissant (213 CFM).\nLes **jambières restent à l'extérieur** pendant le séchage — elles sont trop grandes. [Voir le sac](/products/goalie-hockey-bag-dryer)",
      en: "Yes: the **PRO for goalie**, 42 x 16 x 18 in, with a more powerful fan (213 CFM).\n**Leg pads stay outside** while drying — they're simply too big. [See the bag](/products/goalie-hockey-bag-dryer)"
    }
  },
  {
    id: 'inclus',
    title: { fr: 'Ce qui vient dans la boîte', en: "What's in the box" },
    tags: ['inclus','boite','ventilateur','alimentation','cartouche'],
    q: {
      fr: ['qu est ce qui est inclus','qu est ce qui vient avec le sac','est ce que le ventilateur est inclus','faut il acheter autre chose','contenu de la boite'],
      en: ['what is included','what comes with the bag','is the fan included','do i need to buy anything else','what is in the box']
    },
    a: {
      fr: "Tout est dans la boîte : le **ventilateur déjà installé**, le **bloc d'alimentation 110 V**, **3 mois de cartouches Freshplex™** et le guide d'utilisation.\nRien d'autre à acheter.",
      en: "Everything's in the box: the **fan already installed**, the **110 V power supply**, a **3-month supply of Freshplex™ cartridges** and the user guide.\nNothing else to buy."
    }
  },
  {
    id: 'prix',
    title: { fr: 'Le prix des sacs', en: 'Bag prices' },
    tags: ['prix','sac','cout','modele'],
    q: {
      fr: ['combien coute un sac','quel est le prix','prix des sacs','ca coute combien','combien coute le sac de gardien','prix du sac deluxe','prix du sac pro'],
      en: ['how much is a bag','what is the price','price list','how much does it cost','how much is the goalie bag','price of the deluxe bag','price of the pro bag']
    },
    a: {
      fr: "**PRO joueur** 359,99 $ · **DELUXE Junior** 409,99 $ · **DELUXE Adulte** 434,99 $ · **PRO gardien** 434,99 $ (avant taxes).\nAvec roues : environ 30 $ de plus. **Livraison gratuite** au Canada et aux États-Unis. [Voir les sacs](/collections/all)",
      en: "**PRO player** $359.99 · **DELUXE Junior** $409.99 · **DELUXE Adult** $434.99 · **PRO goalie** $434.99 (before tax).\nWith wheels: about $30 more. **Free shipping** in Canada and the U.S. [See the bags](/collections/all)"
    }
  },
  {
    id: 'couleurs',
    title: { fr: 'Les couleurs offertes', en: 'Available colours' },
    tags: ['couleur','sac'],
    q: {
      fr: ['quelles couleurs sont offertes','avez vous du rouge','couleurs disponibles','est ce qu il y a du bleu'],
      en: ['what colors are available','do you have red','available colours','is there a blue one']
    },
    a: {
      fr: "**Noir, marine, rouge et bleu royal.** La disponibilité en direct est sur la page de chaque produit.\n[Voir les sacs](/collections/all)",
      en: "**Black, navy, red and royal blue.** Live availability is shown on each product page.\n[See the bags](/collections/all)"
    }
  },
  {
    id: 'roues',
    title: { fr: 'Les roues', en: 'Wheels' },
    tags: ['roues','sac','transport'],
    q: {
      fr: ['est ce qu il y a des roues','sac avec roues','les roues sont elles solides','ca vaut la peine les roues'],
      en: ['does it have wheels','bag with wheels','are the wheels sturdy','is the wheelie version worth it']
    },
    a: {
      fr: "Chaque modèle existe **avec ou sans roues** (environ 30 $ de plus).\nCe sont des roues de roller en polyuréthane sur roulements à billes : robustes et silencieuses.",
      en: "Every model comes **with or without wheels** (about $30 more).\nThey're polyurethane rollerblade wheels on ball bearings: tough and quiet."
    }
  },
  {
    id: 'dimensions',
    title: { fr: 'Les dimensions et le poids', en: 'Dimensions and weight' },
    tags: ['dimension','taille','sac'],
    q: {
      fr: ['quelles sont les dimensions','mesures du sac','poids du sac','est ce que le sac est rigide','ca prend combien de place','capacite en litres','dimensions du deluxe adulte','dimensions du deluxe junior','dimensions du sac pro','capacite du sac de gardien','combien de litres'],
      en: ['what are the dimensions','bag measurements','how much does it weigh','is the bag rigid','how much space does it take','capacity in litres','deluxe adult dimensions','deluxe junior dimensions','pro bag dimensions','goalie bag capacity','how many liters']
    },
    a: {
      fr: "**PRO joueur** 36 x 16 x 20 po (189 L) · **PRO gardien** 42 x 16 x 18 po (170 L) · **DELUXE Junior** 36 x 16 x 18 po (202 L) · **DELUXE Adulte** 42 x 20 x 20 po (275 L).\nPoids : environ 10,8 lb. Le sac est souple, seule la structure intérieure est rigide.",
      en: "**PRO player** 36 x 16 x 20 in (189 L) · **PRO goalie** 42 x 16 x 18 in (170 L) · **DELUXE Junior** 36 x 16 x 18 in (202 L) · **DELUXE Adult** 42 x 20 x 20 in (275 L).\nWeight: about 10.8 lb. The bag is soft — only the inner structure is rigid."
    }
  },
  {
    id: 'materiel',
    title: { fr: 'La solidité du sac', en: 'How durable the bag is' },
    tags: ['materiel','sac','zip'],
    q: {
      fr: ['est ce que le sac est resistant','quel tissu','ca dure combien de temps','fabrique ou','est ce que c est de bonne qualite'],
      en: ['is the bag durable','what fabric is it','how long does it last','where is it made','is it good quality']
    },
    a: {
      fr: "Tissu de type **toile de camion**, zips de qualité, passepoil qui ne craque pas au froid, vis en acier inoxydable.\n**Conçu et fabriqué au Canada** — c'est pour ça qu'on couvre les bris 360 jours.",
      en: "**Truck-tarp grade fabric**, quality zippers, piping that doesn't crack in the cold, stainless steel screws.\n**Designed and made in Canada** — that's why we cover breakage for 360 days."
    }
  },
  {
    id: 'autres-sports',
    title: { fr: 'Pour les autres sports', en: 'For other sports' },
    tags: ['autresport','sac','equipement'],
    q: {
      fr: ['est ce que ca marche pour la ringuette','pour le football','autre sport que le hockey','sac de dek hockey','pour la crosse'],
      en: ['does it work for ringette','for football','other sports than hockey','dek hockey bag','for lacrosse']
    },
    a: {
      fr: "Oui : ringuette, dek hockey, crosse, football — tout équipement qui ne va pas à la sécheuse.\nNous avons aussi un modèle **DEK Hockey**. [Voir le sac DEK](/products/dek-hockey-travel-bag)",
      en: "Yes: ringette, dek hockey, lacrosse, football — any gear that can't go in a dryer.\nWe also make a **DEK Hockey** model. [See the DEK bag](/products/dek-hockey-travel-bag)"
    }
  },
  {
    id: 'sac-seul',
    title: { fr: 'Acheter le sac seul', en: 'Buying the shell only' },
    tags: ['sac','structure','remplacement','systeme'],
    q: {
      fr: ['puis je acheter le sac sans le systeme','sac de remplacement seulement','acheter la coque seule','transferer ma structure dans un nouveau sac','vendez vous le systeme de sechage seul'],
      en: ['can i buy the bag without the system','replacement shell only','buy just the bag','transfer my drying structure to a new bag','do you sell the drying system alone']
    },
    a: {
      fr: "Oui, on vend des **coques de remplacement** sans système : vous transférez votre structure dans le nouveau sac (vidéo fournie).\nÀ partir de 159,99 $ (PRO), 189,99 $ (DELUXE), 199,99 $ (gardien). [Voir](/collections/all)",
      en: "Yes, we sell **replacement shells** without the system: you move your structure into the new bag (we send a how-to video).\nFrom $159.99 (PRO), $189.99 (DELUXE), $199.99 (goalie). [See them](/collections/all)"
    }
  },
  {
    id: 'nametag',
    title: { fr: 'La plaque nominative', en: 'Custom nametag' },
    tags: ['nametag','personnalise','nom'],
    q: {
      fr: ['peut on mettre un nom sur le sac','plaque nominative','identifier le sac','nametag brode'],
      en: ['can i put a name on the bag','name tag','identify the bag','embroidered nametag']
    },
    a: {
      fr: "Oui, des **plaques nominatives brodées** aux couleurs de votre équipe, 29,99 $.\nEn glisser une n'empêche pas de retourner le sac dans les 60 jours. [Voir](/products/nametag)",
      en: "Yes, **embroidered nametags** in your team colours, $29.99.\nSlipping one in doesn't prevent returning the bag within 60 days. [See it](/products/nametag)"
    }
  },
  {
    id: 'equipe-logo',
    title: { fr: 'Commande d’équipe avec logo', en: 'Team orders with your logo' },
    tags: ['equipe','gros','personnalise'],
    q: {
      fr: ['commande pour une equipe','sacs avec notre logo','prix de gros','revendeur','commande en quantite','broderie du logo'],
      en: ['team order','bags with our logo','wholesale pricing','become a dealer','bulk order','logo embroidery']
    },
    a: {
      fr: "Oui : **minimum 10 sacs**, modèle PRO, **4 à 8 semaines** de production après approbation du logo.\nÉcrivez à **info@drysnake.com** avec la quantité et votre logo pour une soumission.",
      en: "Yes: **minimum 10 bags**, PRO model, **4 to 8 weeks** of production after the logo is approved.\nEmail **info@drysnake.com** with the quantity and your logo for a quote."
    }
  },
  {
    id: 'cadeau',
    title: { fr: 'Offrir un sac en cadeau', en: 'Giving a bag as a gift' },
    tags: ['cadeau','carte'],
    q: {
      fr: ['carte cadeau','je veux l offrir en cadeau','et si la personne n est pas satisfaite','cadeau de noel','cadeau d anniversaire'],
      en: ['gift card','i want to give it as a gift','what if the person is not satisfied','christmas gift','birthday gift']
    },
    a: {
      fr: "Des **cartes-cadeaux de 25 $ à 200 $** sont livrées par courriel. [Voir](/products/gift-card)\nEt si vous offrez un sac, la garantie **60 jours satisfait ou remboursé** s'applique quand même.",
      en: "**Gift cards from $25 to $200**, delivered by email. [See them](/products/gift-card)\nAnd if you give a bag, the **60-day money-back guarantee** still applies."
    }
  },

  /* ---------- FONCTIONNEMENT ---------- */
  {
    id: 'temps-sechage',
    title: { fr: 'Le temps de séchage', en: 'Drying time' },
    tags: ['delai','secher','sechage'],
    q: {
      fr: ['combien de temps pour secher l equipement','ca prend combien de temps a secher','temps de sechage','est ce que c est sec le lendemain'],
      en: ['how long does it take to dry','drying time','how long to dry the gear','is it dry the next morning']
    },
    a: {
      fr: "Environ **3 heures** dans une pièce normale — vous branchez en rentrant, c'est sec même entre deux matchs.\nDans un garage froid ou humide, c'est plus long : rapprochez le sac d'une source de chaleur.",
      en: "About **3 hours** in a normal room — plug it in when you get home and it's dry, even between two games.\nIn a cold or damp garage it takes longer: move the bag near a heat source."
    }
  },
  {
    id: 'comment-ca-marche',
    title: { fr: 'Comment le système fonctionne', en: 'How the system works' },
    tags: ['fonctionne','secher','structure','systeme','chauffant'],
    q: {
      fr: ['comment ca fonctionne','est ce que c est chauffant','comment le sac seche l equipement','a quoi servent les tuyaux','est ce que c est de l air chaud'],
      en: ['how does it work','is it heated','how does the bag dry the gear','what are the tubes for','is it hot air']
    },
    a: {
      fr: "C'est de la **ventilation, pas du chauffage** : le ventilateur pousse l'air ambiant dans des tubes qui l'amènent au fond de chaque pièce d'équipement.\nChaque pièce a sa sortie d'air, et vous ne sortez rien du sac. [Comment ça marche](/pages/technology)",
      en: "It's **ventilation, not heat**: the fan pushes ambient air through tubes that carry it to the bottom of each piece of gear.\nEvery piece gets its own outlet, and you never unpack the bag."
    }
  },
  {
    id: 'pourquoi-odeur',
    title: { fr: 'Pourquoi l’équipement pue', en: 'Why gear smells' },
    tags: ['odeur','bacterie','secher'],
    q: {
      fr: ['pourquoi mon equipement pue','d ou vient l odeur','est ce que c est la sueur','bacteries dans l equipement','moisissure'],
      en: ['why does my gear smell','where does the smell come from','is it sweat','bacteria in the gear','mold in the bag']
    },
    a: {
      fr: "Ce n'est pas la sueur : ce sont les **bactéries et moisissures** qui poussent dans l'équipement humide — elles doublent aux 4 à 20 minutes.\nEn séchant vite, on leur retire l'humidité dont elles ont besoin, et l'odeur ne s'installe jamais.",
      en: "It isn't sweat: it's **bacteria and mould** growing in damp gear — they double every 4 to 20 minutes.\nDrying fast removes the moisture they need, so the smell never sets in."
    }
  },
  {
    id: 'laisser-branche',
    title: { fr: 'Le laisser branché, minuterie', en: 'Leaving it plugged in, timer' },
    tags: ['fonctionne','minuterie','branche','nuit'],
    q: {
      fr: ['est ce qu il y a une minuterie','puis je le laisser branche tout le temps','est ce dangereux de le laisser la nuit','ca s arrete tout seul'],
      en: ['is there a timer','can i leave it plugged in','is it safe to leave it overnight','does it shut off by itself']
    },
    a: {
      fr: "**Pas de minuterie**, c'est voulu : le système est fait pour tourner en continu.\nLaissez-le toute la nuit sans souci — il peut rester branché en permanence.",
      en: "**No timer**, by design: the system is built to run continuously.\nLeave it on overnight without worry — it can stay plugged in permanently."
    }
  },
  {
    id: 'electricite',
    title: { fr: 'La consommation électrique', en: 'Electricity use' },
    tags: ['electricite','cout','consommation'],
    q: {
      fr: ['combien ca consomme','ca coute cher en electricite','consommation electrique','est ce que ca fait monter la facture'],
      en: ['how much electricity does it use','is it expensive to run','power consumption','will it raise my bill']
    },
    a: {
      fr: "Environ **7 watts**, soit 7 fois moins qu'une ampoule de 50 W.\nL'impact sur la facture est négligeable, même branché tous les jours.",
      en: "About **7 watts** — seven times less than a 50 W bulb.\nThe impact on your bill is negligible, even running it daily."
    }
  },
  {
    id: 'bruit',
    title: { fr: 'Le bruit du ventilateur', en: 'Fan noise' },
    tags: ['bruit','ventilateur'],
    q: {
      fr: ['est ce que le ventilateur fait du bruit','c est bruyant','combien de decibels','le ventilateur est trop fort','ventilateur silencieux'],
      en: ['is the fan noisy','how loud is it','how many decibels','the fan is too loud','quieter fan']
    },
    a: {
      fr: "Oui, on l'entend : c'est comparable à un ventilateur de table, **entre 53 et 64 décibels** selon le modèle (le gardien est le plus puissant).\nSi ça vous dérange, demandez le ventilateur silencieux dans les notes à la caisse. Un bruit de frottement, lui, n'est pas normal.",
      en: "Yes, you hear it: comparable to a table fan, **between 53 and 64 decibels** depending on the model (the goalie one is the most powerful).\nIf it bothers you, ask for the quieter fan in the order notes. A grinding noise, though, is not normal."
    }
  },
  {
    id: 'odeurs',
    title: { fr: 'Le contrôle des odeurs', en: 'Odor control' },
    tags: ['odeur','cartouche'],
    q: {
      fr: ['est ce que ca enleve les odeurs','mon equipement sent encore mauvais','comment controler les odeurs','freshplex'],
      en: ['does it remove odors','my gear still smells','how are odors controlled','what is freshplex']
    },
    a: {
      fr: "Le séchage fait l'essentiel : sans humidité, les bactéries responsables de l'odeur ne poussent plus.\nLes **cartouches Freshplex™** neutralisent les molécules d'odeur à la source (elles ne masquent pas). [Éliminateur d'odeurs](/products/odor-eliminator)",
      en: "Drying does most of the work: without moisture, the bacteria behind the smell don't grow.\nThe **Freshplex™ cartridges** neutralize odour molecules at the source (they don't mask). [Odor eliminator](/products/odor-eliminator)"
    }
  },
  {
    id: 'cartouches-usage',
    title: { fr: 'Les cartouches désodorisantes', en: 'Deodorizing cartridges' },
    tags: ['cartouche','odeur','remplacer'],
    q: {
      fr: ['a quelle frequence changer les cartouches','ca dure combien de temps une cartouche','ou mettre les cartouches','comment installer les cartouches','combien de cartouches par mois'],
      en: ['how often do i change the cartridges','how long does a cartridge last','where do the cartridges go','how do i install the cartridges','how many cartridges per month']
    },
    a: {
      fr: "**2 cartouches à la fois, à changer chaque mois.** Elles se placent dans les petits trous devant le ventilateur.\n3 mois de réserve viennent avec le sac. [Commander](/products/deodorizing-cartridges)",
      en: "**2 cartridges at a time, changed monthly.** They sit in the small holes in front of the fan.\nA 3-month supply comes with the bag. [Order more](/products/deodorizing-cartridges)"
    }
  },
  {
    id: 'cartouches-liquide',
    title: { fr: 'Le liquide dans les cartouches', en: 'Liquid in the cartridges' },
    tags: ['cartouche','liquide','rangement'],
    q: {
      fr: ['il y a du liquide dans le sachet des cartouches','mes cartouches sont mouillees','est ce que mes cartouches sont defectueuses','les cartouches se conservent combien de temps'],
      en: ['there is liquid in the cartridge pouch','my cartridges are wet','are my cartridges defective','how long can cartridges be stored']
    },
    a: {
      fr: "C'est **normal** : on laisse volontairement un fond de liquide dans le sachet pour qu'elles restent imbibées plus longtemps.\nSi ça vous dérange, épongez-les avant de les installer.",
      en: "That's **normal**: we deliberately leave a bit of liquid in the pouch so they stay saturated longer.\nIf it bothers you, blot them before installing."
    }
  },
  {
    id: 'laver',
    title: { fr: 'Laver l’équipement et le sac', en: 'Washing the gear and the bag' },
    tags: ['laver','equipement','sac','entretien'],
    q: {
      fr: ['est ce que je peux laver l equipement','peut on laver le sac','comment nettoyer le sac','equipement a la laveuse'],
      en: ['can i wash the gear','can the bag be washed','how do i clean the bag','equipment in the washing machine']
    },
    a: {
      fr: "Un **guide de lavage est inclus** avec le sac : la plupart des pièces vont à la machine, **patins et casque se nettoient à la main**.\nLe sac lui-même : linge humide et savon doux.",
      en: "A **washing guide comes with the bag**: most gear can go in the machine, **skates and helmets are cleaned by hand**.\nThe bag itself: damp cloth and mild soap."
    }
  },
  {
    id: 'vetements',
    title: { fr: 'Le séchage des vêtements', en: 'Drying clothes' },
    tags: ['secher','vetement'],
    q: {
      fr: ['est ce que ca seche les vetements','ca seche le chandail et les bas','sous vetements'],
      en: ['does it dry clothes','does it dry the jersey and socks','underwear']
    },
    a: {
      fr: "Un peu, mais ce n'est pas sa raison d'être : le sac est fait pour l'équipement qui **ne peut pas aller à la sécheuse**.\nSuspendez chandail et bas après la séance.",
      en: "Somewhat, but that's not the point: the bag is made for gear that **can't go in a dryer**.\nHang the jersey and socks after a session."
    }
  },
  {
    id: 'auto-arena',
    title: { fr: 'Utiliser le sac sans prise murale', en: 'Using it away from a wall outlet' },
    tags: ['auto','alimentation','tournoi','casier','prise'],
    q: {
      fr: ['puis je l utiliser dans l auto','sans prise de courant','batterie portative','dans le vestiaire a l arena','en tournoi'],
      en: ['can i use it in the car','without a power outlet','portable battery','in the locker room','at a tournament']
    },
    a: {
      fr: "Oui : le **cordon pour l'auto** (34,99 $) ou la **batterie externe** 12 V (79,99 $, environ 6 heures, sacs de joueur seulement).\n[Cordon](/products/power-cord-for-motor-vehicle) · [Batterie](/products/power-bank)",
      en: "Yes: the **car power cord** ($34.99) or the **power bank** 12V ($79.99, about 6 hours, player bags only).\n[Cord](/products/power-cord-for-motor-vehicle) · [Power bank](/products/power-bank)"
    }
  },
  {
    id: 'adaptateur-international',
    title: { fr: 'Adaptateur pour l’étranger', en: 'Power adapter abroad' },
    tags: ['alimentation','international','electricite','prise'],
    q: {
      fr: ['quel voltage','est ce que ca marche en europe','adaptateur 220 volts','prise europeenne','le bloc d alimentation est de quel type'],
      en: ['what voltage is it','does it work in europe','220 volt adapter','european plug','what type of power supply']
    },
    a: {
      fr: "Les sacs partent avec un **bloc d'alimentation 110 V** (Amérique du Nord).\nÀ l'étranger, demandez un **adaptateur international** à **info@drysnake.com** dès votre commande passée, avant l'expédition.",
      en: "Bags ship with a **110 V power supply** (North America).\nAbroad, request an **international adapter** from **info@drysnake.com** right after ordering, before it ships."
    }
  },
  {
    id: 'rangement',
    title: { fr: 'Ranger le sac pour l’été', en: 'Storing the bag for the summer' },
    tags: ['rangement','cartouche'],
    q: {
      fr: ['comment ranger le sac pour l ete','entreposage longue duree','off season'],
      en: ['how do i store the bag for the summer','long term storage','off season']
    },
    a: {
      fr: "Faites un dernier séchage complet, puis rangez le sac au sec.\n**Retirez les cartouches** et gardez-les dans un Ziploc fermé : elles resteront comme neuves pour la reprise.",
      en: "Run one last full drying cycle, then store the bag somewhere dry.\n**Take the cartridges out** and keep them in a sealed Ziploc: they'll be as good as new next season."
    }
  },

  /* ---------- GARANTIE / RETOURS ---------- */
  {
    id: 'garantie',
    title: { fr: 'La garantie', en: 'The warranty' },
    tags: ['garantie','sac','remboursement','duree'],
    q: {
      fr: ['c est quoi la garantie','combien de temps de garantie','est ce que mon sac est encore garanti','la garantie couvre quoi'],
      en: ['what is the warranty','how long is the warranty','is my bag still covered','what does the warranty cover']
    },
    a: {
      fr: "**60 jours satisfait ou remboursé** (Canada et États-Unis) et **360 jours sur les bris** : ventilateur, bloc d'alimentation, couture, zip ou roue, tout est réparé ou remplacé sans frais, partout dans le monde.\n[Notre garantie](/pages/warranty)",
      en: "**60-day money-back guarantee** (Canada and the U.S.) and **360 days on breakage**: fan, power supply, seam, zipper or wheel — all repaired or replaced free of charge, worldwide.\n[Our warranty](/pages/warranty)"
    }
  },
  {
    id: 'retour-comment',
    title: { fr: 'Comment retourner un sac', en: 'How to return a bag' },
    tags: ['retour','remboursement','procedure','boite'],
    q: {
      fr: ['comment retourner un sac','je veux retourner ma commande','procedure de retour','est ce que je dois garder la boite','qui paie le retour'],
      en: ['how do i return a bag','i want to return my order','return process','do i need to keep the box','who pays for the return','can i return it if it does not suit me','how do returns work']
    },
    a: {
      fr: "Écrivez à **info@drysnake.com** avec votre numéro de commande : on vous envoie l'étiquette de retour.\n**Gardez la boîte d'origine**, retournez seulement le sac (gardez les accessoires). Les frais de retour (environ 24 $ au Qc/Ont.) sont déduits du remboursement.",
      en: "Email **info@drysnake.com** with your order number and we'll send the return label.\n**Keep the original box**, send back only the bag (keep the accessories). Return shipping (about $24 in QC/ON) is deducted from the refund."
    }
  },
  {
    id: 'retour-international',
    title: { fr: 'Retours hors Canada et É.-U.', en: 'Returns outside Canada and the U.S.' },
    tags: ['international'],
    q: {
      fr: ['puis je retourner mon sac si je suis en europe','retour depuis l etranger','est ce que la politique 60 jours s applique hors canada','les ventes internationales sont elles finales','retour hors canada et etats unis'],
      en: ['can i return my bag from europe','international return','does the 60 day policy apply outside canada','are international sales final','return from outside canada and the us']
    },
    a: {
      fr: "Depuis le **28 avril 2026**, les commandes hors Canada et États-Unis ne sont **plus admissibles au retour de 60 jours** — ces ventes sont finales.\nLa **garantie de réparation de 360 jours s'applique quand même** : écrivez à info@drysnake.com.",
      en: "Since **April 28, 2026**, orders outside Canada and the U.S. are **no longer eligible for the 60-day return** — those sales are final.\nThe **360-day repair warranty still applies**: email info@drysnake.com."
    }
  },
  {
    id: 'remboursement-delai',
    title: { fr: 'Le délai de remboursement', en: 'Refund timing' },
    tags: ['remboursement','delai','argent'],
    q: {
      fr: ['quand vais je recevoir mon remboursement','ca prend combien de temps le remboursement','je n ai pas encore recu mon argent'],
      en: ['when will i get my refund','how long does a refund take','i have not received my money']
    },
    a: {
      fr: "Le remboursement part dès la réception du colis, puis comptez **jusqu'à 10 jours ouvrables** pour le voir sur votre relevé.\nPassé 15 jours ouvrables, écrivez-nous à info@drysnake.com.",
      en: "The refund is issued as soon as we receive the package, then allow **up to 10 business days** to see it on your statement.\nAfter 15 business days, email us at info@drysnake.com."
    }
  },
  {
    id: 'echange',
    title: { fr: 'Échanger un modèle ou une couleur', en: 'Exchanging a model or colour' },
    tags: ['echange','modele','couleur','taille'],
    q: {
      fr: ['je me suis trompe de modele','puis je echanger la couleur','changer pour une autre grandeur','echanger mon sac'],
      en: ['i ordered the wrong model','can i exchange the colour','change to another size','exchange my bag']
    },
    a: {
      fr: "Le plus rapide : **retourner l'article et recommander le bon modèle** — votre nouveau sac part tout de suite.\nÉcrivez à **info@drysnake.com** avec votre numéro de commande, on envoie l'étiquette de retour.",
      en: "Fastest way: **return the item and place a new order** — your new bag ships right away.\nEmail **info@drysnake.com** with your order number and we'll send the return label."
    }
  },
  {
    id: 'satisfaction',
    title: { fr: 'L’essai de 60 jours', en: 'The 60-day trial' },
    tags: ['garantie','essai','risque','remboursement'],
    q: {
      fr: ['et si le sac ne me convient pas','est ce que je peux l essayer','c est cher je ne suis pas sur','est ce risque comme achat'],
      en: ['what if the bag does not suit me','can i try it','it is expensive i am not sure','is it a risky purchase']
    },
    a: {
      fr: "Vous l'essayez **60 jours** (Canada et États-Unis). S'il ne fait pas l'affaire, on rembourse — gardez simplement la boîte.\nEt pendant **360 jours**, tout bris est réparé à nos frais. [Notre garantie](/pages/warranty)",
      en: "You try it for **60 days** (Canada and the U.S.). If it's not right, we refund — just keep the box.\nAnd for **360 days**, any breakage is fixed at our cost. [Our guarantee](/pages/warranty)"
    }
  },
  {
    id: 'care-plus',
    title: { fr: 'Drysnake Care+', en: 'Drysnake Care+' },
    tags: ['careplus','garantie','abonnement'],
    q: {
      fr: ['c est quoi drysnake care','garantie prolongee','care plus','abonnement de protection'],
      en: ['what is drysnake care','extended warranty','care plus','protection membership']
    },
    a: {
      fr: "**49,99 $ par année.** Ça prolonge la protection au-delà des 360 jours et couvre aussi les **bris accidentels et l'usure** (zip, ventilateur, déchirure).\n12 mois de cartouches offerts à l'adhésion, annulable en tout temps. [Voir Care+](/products/drysnake-care)",
      en: "**$49.99 a year.** It extends coverage beyond the 360 days and also covers **accidental damage and wear** (zipper, fan, tears).\n12 months of cartridges included when you join, cancel anytime. [See Care+](/products/drysnake-care)"
    }
  },

  /* ---------- LIVRAISON / COMMANDES ---------- */
  {
    id: 'livraison-delai',
    title: { fr: 'Les délais de livraison', en: 'Shipping times' },
    tags: ['livraison','delai','canada'],
    q: {
      fr: ['quel est le delai de livraison','en combien de temps je vais le recevoir','quand ca part','livraison au quebec','si je commande aujourdhui je le recois quand','quand vais je recevoir ma commande','en combien de jours je recois ma commande'],
      en: ['what is the shipping time','how long until i receive it','when does it ship','shipping to canada','if i order today when will i receive it','how many days to receive my order']
    },
    a: {
      fr: "Expédié **le jour même ou le jour ouvrable suivant**, avec numéro de suivi par courriel.\n**Québec** 1-3 jours · **Reste du Canada** 3-7 jours · **États-Unis** 4-7 jours · **International** 7-14 jours ouvrables.",
      en: "Shipped **same day or next business day**, with a tracking number by email.\n**Quebec** 1-3 days · **Rest of Canada** 3-7 days · **United States** 4-7 days · **International** 7-14 business days."
    }
  },
  {
    id: 'livraison-gratuite',
    title: { fr: 'Les frais de livraison', en: 'Shipping costs' },
    tags: ['livraison','gratuit','prix'],
    q: {
      fr: ['est ce que la livraison est gratuite','combien coutent les frais de livraison','frais de port','livraison gratuite a partir de combien'],
      en: ['is shipping free','how much is shipping','shipping cost','free shipping threshold']
    },
    a: {
      fr: "**La livraison est gratuite au Canada et aux États-Unis** sur toute commande contenant un sac, sans minimum.\nPour les accessoires seuls, des frais réduits s'affichent au panier.",
      en: "**Shipping is free in Canada and the U.S.** on any order containing a bag, no minimum.\nFor accessories alone, a reduced fee is shown in the cart."
    }
  },
  {
    id: 'livraison-usa',
    title: { fr: 'La livraison aux États-Unis', en: 'Shipping to the United States' },
    tags: ['livraison','taxes','usa','douane'],
    q: {
      fr: ['livrez vous aux etats unis','frais de douane pour les usa','y a t il des tarifs douaniers','est ce que je vais payer des frais a la frontiere'],
      en: ['do you ship to the united states','customs fees for the us','are there tariffs','will i pay fees at the border']
    },
    a: {
      fr: "Oui, et la **livraison est gratuite** vers les États-Unis (4 à 7 jours ouvrables).\nNos sacs sont couverts par un **certificat ACEUM** : aucun droit de douane ni frais de courtier à la réception.",
      en: "Yes, and **shipping is free** to the United States (4 to 7 business days).\nOur bags carry a **USMCA certificate**: no customs duties and no broker fees on delivery."
    }
  },
  {
    id: 'livraison-intl',
    title: { fr: 'La livraison à l’international', en: 'International shipping' },
    tags: ['livraison','international','taxes','douane'],
    q: {
      fr: ['livrez vous en europe','expedition internationale','livraison en france','livraison en allemagne','livraison en suisse','livraison au mexique','est ce que vous livrez a l etranger','expediez vous partout dans le monde'],
      en: ['do you ship to europe','international shipping','shipping to germany','shipping to switzerland','shipping to japan','shipping to australia','do you ship overseas','do you ship worldwide']
    },
    a: {
      fr: "Oui, nous expédions partout dans le monde, en **7 à 14 jours ouvrables**.\nLe tarif **inclut déjà douanes, taxes et courtage** : rien de plus à payer. À noter : bloc d'alimentation 110 V, et **pas de retour de 60 jours** hors Canada/É.-U.",
      en: "Yes, we ship worldwide in **7 to 14 business days**.\nThe rate **already includes customs, taxes and brokerage**: nothing more to pay. Note: 110 V power supply, and **no 60-day return** outside Canada/the U.S."
    }
  },
  {
    id: 'taxes',
    title: { fr: 'Les taxes', en: 'Taxes' },
    tags: ['taxes','prix'],
    q: {
      fr: ['est ce que les taxes sont incluses','les prix affiches incluent ils les taxes','combien de taxes'],
      en: ['are taxes included','do prices include tax','how much tax']
    },
    a: {
      fr: "Les prix affichés sont **avant taxes** ; celles de votre province ou pays s'ajoutent à la caisse.\nÀ l'international, douanes et taxes d'importation sont **déjà comprises** dans la livraison.",
      en: "Prices shown are **before tax**; your province's or country's taxes are added at checkout.\nInternationally, customs and import taxes are **already included** in the shipping rate."
    }
  },
  {
    id: 'suivi',
    title: { fr: 'Le suivi de commande', en: 'Order tracking' },
    tags: ['suivi','commande','livraison','colis'],
    q: {
      fr: ['ou est ma commande','numero de suivi','je n ai pas recu mon colis','suivi de commande','ma commande est en retard'],
      en: ['where is my order','tracking number','i have not received my package','order tracking','my order is late']
    },
    a: {
      fr: "Je n'ai pas accès aux commandes depuis le chat. Le **numéro de suivi part par courriel dès l'expédition** — vérifiez vos indésirables.\nSinon, écrivez à **info@drysnake.com** avec votre numéro de commande.",
      en: "I don't have access to orders from the chat. The **tracking number is emailed as soon as it ships** — check your spam folder.\nOtherwise, email **info@drysnake.com** with your order number."
    }
  },
  {
    id: 'colis-perdu',
    title: { fr: 'Colis perdu, volé ou abîmé', en: 'Lost, stolen or damaged package' },
    tags: ['perdu','colis','livraison','suivi'],
    q: {
      fr: ['mon colis est perdu','le colis a ete vole','ma boite est arrivee endommagee','le suivi dit livre mais je n ai rien recu','signature a la livraison'],
      en: ['my package is lost','the package was stolen','my box arrived damaged','tracking says delivered but nothing arrived','signature on delivery']
    },
    a: {
      fr: "Colis **perdu en transit ou abîmé** : on le remplace sans frais. Écrivez à **info@drysnake.com** avec votre numéro de commande et des photos.\nUne fois marqué « livré » par le transporteur, on ne peut plus le couvrir — demandez l'option signature si les vols sont fréquents chez vous.",
      en: "Package **lost in transit or damaged**: we replace it free of charge. Email **info@drysnake.com** with your order number and photos.\nOnce the carrier marks it \"delivered\" we can't cover it — ask for the signature option if theft is common where you live."
    }
  },
  {
    id: 'modifier-commande',
    title: { fr: 'Modifier ou annuler une commande', en: 'Changing or cancelling an order' },
    tags: ['adresse','annuler','echange','modifier'],
    q: {
      fr: ['je veux changer mon adresse de livraison','puis je annuler ma commande','modifier ma commande','erreur dans mon adresse'],
      en: ['i want to change my shipping address','can i cancel my order','modify my order','wrong address on my order']
    },
    a: {
      fr: "Possible tant que le colis n'est pas parti — et il part vite. Écrivez tout de suite à **info@drysnake.com** avec votre numéro de commande.\nS'il est déjà en route, on peut souvent faire rediriger la livraison.",
      en: "Possible as long as it hasn't shipped — and it ships fast. Email **info@drysnake.com** right away with your order number.\nIf it's already on the way, we can often have the carrier redirect it."
    }
  },
  {
    id: 'stock',
    title: { fr: 'La disponibilité en stock', en: 'Stock availability' },
    tags: ['stock','sac','couleur'],
    q: {
      fr: ['est ce que c est en stock','rupture de stock','quand sera t il disponible','retour en stock','est ce que le sac rouge est en stock','cette couleur est elle disponible','avez vous ce modele en stock'],
      en: ['is it in stock','out of stock','when will it be available','back in stock','is the red bag in stock','is this colour available']
    },
    a: {
      fr: "La disponibilité affichée sur la page produit est **en direct** : si vous pouvez l'ajouter au panier, c'est en stock.\nPour un modèle épuisé, écrivez à **info@drysnake.com** — on peut vous en réserver un.",
      en: "Availability on the product page is **live**: if you can add it to your cart, it's in stock.\nFor a sold-out model, email **info@drysnake.com** — we can set one aside for you."
    }
  },
  {
    id: 'boutique',
    title: { fr: 'Boutique et ramassage', en: 'Store and pickup' },
    tags: ['boutique','ramassage','adresse'],
    q: {
      fr: ['avez vous un magasin','ou etes vous situes','puis je passer chercher ma commande','ramassage en personne','ou essayer le sac'],
      en: ['do you have a store','where are you located','can i pick up my order','local pickup','where can i see the bag']
    },
    a: {
      fr: "Vente **en ligne seulement**, mais notre atelier est à **Gatineau** : 1870, boul. Maloney Est.\nRamassage possible sur place — écrivez d'abord à info@drysnake.com pour convenir d'un moment.",
      en: "We sell **online only**, but our workshop is in **Gatineau**: 1870 Boul. Maloney E.\nLocal pickup is possible — email info@drysnake.com first to arrange a time."
    }
  },

  /* ---------- DÉPANNAGE ---------- */
  {
    id: 'ventilateur-panne',
    title: { fr: 'Le ventilateur ne fonctionne pas', en: 'The fan is not working' },
    tags: ['ventilateur','fonctionne','alimentation','reparation'],
    q: {
      fr: ['mon ventilateur ne fonctionne pas','le ventilateur ne part pas','le fan ne marche plus','mon sac ne souffle plus','plus rien ne fonctionne'],
      en: ['my fan is not working','the fan does not start','fan stopped working','no air coming out','nothing works anymore']
    },
    a: {
      fr: "Dans presque tous les cas, **c'est le bloc d'alimentation, pas le ventilateur**. Essayez une autre prise et vérifiez que la petite lumière du bloc est verte.\nEnsuite écrivez à **info@drysnake.com** avec votre numéro de commande et une courte vidéo — **sous 360 jours, la pièce est gratuite**.",
      en: "In almost every case, **it's the power supply, not the fan**. Try another outlet and check that the small light on the supply is green.\nThen email **info@drysnake.com** with your order number and a short video — **under 360 days the part is free**."
    }
  },
  {
    id: 'pieces',
    title: { fr: 'Les pièces de rechange', en: 'Replacement parts' },
    tags: ['ventilateur','alimentation','pieces','remplacement'],
    q: {
      fr: ['ou acheter un ventilateur de remplacement','prix d un bloc d alimentation','commander une piece','piece de rechange'],
      en: ['where can i buy a replacement fan','price of a power supply','order a part','spare parts']
    },
    a: {
      fr: "**Bloc d'alimentation** 34,99 $ (joueur) / 44,99 $ (gardien) · **Ventilateur** 49,99 $ / 69,99 $ · **Cordon auto** 34,99 $.\nCommencez par le bloc d'alimentation, c'est presque toujours lui. **Sous 360 jours, ne payez rien** : écrivez à info@drysnake.com. [Pièces](/products/wall-power-supply)",
      en: "**Power supply** $34.99 (player) / $44.99 (goalie) · **Fan** $49.99 / $69.99 · **Car cord** $34.99.\nStart with the power supply, it's almost always the culprit. **Under 360 days, don't pay** — email info@drysnake.com. [Parts](/products/wall-power-supply)"
    }
  },
  {
    id: 'couture-zip',
    title: { fr: 'Zip ou couture brisée', en: 'Broken zipper or seam' },
    tags: ['reparation','zip','sac'],
    q: {
      fr: ['mon zip est brise','une couture se defait','mon sac est dechire','le sac est brise','reparer mon sac'],
      en: ['my zipper is broken','a seam is coming apart','my bag is torn','the bag is broken','repair my bag']
    },
    a: {
      fr: "Envoyez **une ou deux photos** à **info@drysnake.com** avec votre numéro de commande.\n**Moins de 360 jours** : réparé ou remplacé à nos frais. **Hors garantie** : on fournit des zips ou une coque à prix réduit.",
      en: "Send **one or two photos** to **info@drysnake.com** with your order number.\n**Under 360 days**: repaired or replaced at our cost. **Out of warranty**: we supply zippers or a shell at a reduced price."
    }
  },
  {
    id: 'piece-manquante',
    title: { fr: 'Une pièce manque dans la boîte', en: 'An item is missing from the box' },
    tags: ['inclus','alimentation','cartouche','manquant'],
    q: {
      fr: ['il manque le cable dans ma boite','je n ai pas recu les cartouches','piece manquante dans ma commande'],
      en: ['the cable was missing from my box','i did not receive the cartridges','missing item in my order']
    },
    a: {
      fr: "Désolé pour l'oubli. Écrivez à **info@drysnake.com** en précisant ce qui manque et votre numéro de commande — c'est réexpédié **sans frais, le jour même ou le lendemain**.",
      en: "Sorry about that. Email **info@drysnake.com** with what's missing and your order number — we re-ship it **free of charge, same or next day**."
    }
  },
  {
    id: 'contact',
    title: { fr: 'Parler à quelqu’un', en: 'Talking to someone' },
    tags: ['contact','courriel'],
    q: {
      fr: ['je veux parler a quelqu un','comment vous joindre','votre numero de telephone','parler a un humain','service a la clientele'],
      en: ['i want to talk to someone','how do i reach you','your phone number','talk to a human','customer service']
    },
    a: {
      fr: "Écrivez à **info@drysnake.com** — Cédrick répond lui-même, en général en quelques heures les jours ouvrables.\n[Formulaire de contact](/pages/contact)",
      en: "Email **info@drysnake.com** — Cédrick answers personally, usually within a few hours on business days.\n[Contact form](/pages/contact)"
    }
  },
  {
    id: 'promo',
    title: { fr: 'Les codes rabais', en: 'Discount codes' },
    tags: ['rabais','prix'],
    q: {
      fr: ['avez vous un code promo','y a t il un rabais','code de reduction','est ce qu il y a des soldes','vendredi fou'],
      en: ['do you have a promo code','is there a discount','coupon code','any sales','black friday']
    },
    a: {
      fr: "Pas de code promo sur demande : le prix est le même pour tout le monde toute l'année.\nNos rares promotions passent par l'infolettre. L'achat reste sans risque : 60 jours satisfait ou remboursé et livraison gratuite.",
      en: "No promo codes on request: the price is the same for everyone all year.\nOur occasional promotions go out through the newsletter. The purchase stays risk-free: 60-day money-back guarantee and free shipping."
    }
  },
  {
    id: 'avis',
    title: { fr: 'Est-ce que ça marche vraiment', en: 'Does it really work' },
    tags: ['avis','preuve','sac'],
    q: {
      fr: ['est ce que ca marche vraiment','avez vous des avis de clients','est ce que les gens aiment ca','ca vaut le prix'],
      en: ['does it really work','do you have customer reviews','do people like it','is it worth the price']
    },
    a: {
      fr: "Plus de **100 000 séchages** faits avec nos sacs, et les avis clients sont publics sur chaque page produit.\nLe produit a été présenté à RDS, TVA Nouvelles et Radio-Canada. [Témoignages](/pages/satisfaction)",
      en: "Over **100,000 drying cycles** run with our bags, and customer reviews are public on every product page.\nThe product has been featured on RDS, TVA Nouvelles and Radio-Canada. [Testimonials](/pages/satisfaction)"
    }
  }

  ]
};


/* ---------- journal.js ---------- */
/* ============================================================================
   Journal des conversations
   ----------------------------------------------------------------------------
   Enregistre chaque question posée au chatbot, pour le rapport hebdomadaire.

   Ce qui est enregistré : la question, la réponse servie, la langue, la page et
   le type d'appareil.
   Ce qui ne l'est JAMAIS : nom, courriel, téléphone, adresse IP. L'identifiant
   de session est un nombre aléatoire qui sert uniquement à regrouper les
   questions d'une même visite, et il disparaît à la fermeture de l'onglet.

   L'envoi ne bloque jamais l'affichage de la réponse : si le réseau échoue,
   le chatbot continue de fonctionner normalement.
   ========================================================================== */
(function (global) {
  'use strict';

  var CFG = {
    url: 'https://cischkjzmrnlmzseglqv.supabase.co',
    cle: 'sb_publishable_xVhLmK173WJ7Z5t4VEQtoQ_FqTHaS5e',
    table: 'chatbot_messages',
    site: 'drysnake'
  };

  var perso = global.JOURNAL_CONFIG || {};
  for (var k in perso) { if (Object.prototype.hasOwnProperty.call(perso, k)) CFG[k] = perso[k]; }

  /* Identifiant de visite : aléatoire, gardé le temps de l'onglet seulement. */
  function sessionId() {
    try {
      var s = sessionStorage.getItem('chat-session');
      if (!s) {
        s = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem('chat-session', s);
      }
      return s;
    } catch (e) {
      return 'anonyme';
    }
  }

  function appareil() {
    return (global.innerWidth && global.innerWidth < 768) ? 'mobile' : 'ordinateur';
  }

  function enregistrer(info) {
    if (!CFG.url || !CFG.cle) return;
    var ligne = {
      site: CFG.site,
      session_id: sessionId(),
      langue: info.langue || null,
      question: String(info.question || '').slice(0, 600),
      reponse_id: info.reponseId ? String(info.reponseId).slice(0, 60) : null,
      repondu: !!info.repondu,
      score: typeof info.score === 'number' ? info.score : null,
      reponse_texte: info.texte ? String(info.texte).slice(0, 2000) : null,
      page: String(location.pathname + location.search).slice(0, 300),
      appareil: appareil()
    };

    try {
      fetch(CFG.url + '/rest/v1/' + CFG.table, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': CFG.cle,
          'Authorization': 'Bearer ' + CFG.cle,
          'Prefer': 'return=minimal'
        },
        body: JSON.stringify(ligne),
        keepalive: true
      }).catch(function () { /* silence : le chatbot doit fonctionner même hors ligne */ });
    } catch (e) { /* idem */ }
  }

  global.JournalChat = { enregistrer: enregistrer, session: sessionId };
})(typeof window !== 'undefined' ? window : globalThis);


/* ---------- memoire.js ---------- */
/* ============================================================================
   Mémoire de visite
   ----------------------------------------------------------------------------
   Permet au chat de reconnaître un visiteur qui revient sur le site, pour
   l'accueillir autrement qu'un nouveau venu et lui reproposer le sujet de la
   dernière fois.

   CE QUI EST GARDÉ (dans le navigateur du visiteur, jamais envoyé nulle part) :
     - le nombre de visites où le chat a été ouvert ;
     - la date de la dernière visite ;
     - jusqu'à 3 IDENTIFIANTS DE SUJET (ex. « garantie », « livraison »).

   CE QUI N'EST JAMAIS GARDÉ :
     - le texte tapé par le visiteur ;
     - nom, courriel, téléphone, adresse IP, identifiant publicitaire.

   Un identifiant de sujet est un mot fixe de notre base de réponses. Il ne
   contient rien d'écrit par la personne. Rien ne sort du navigateur : cette
   mémoire n'est pas envoyée à Supabase ni à personne d'autre.

   Elle s'efface toute seule après 120 jours sans visite, et disparaît si le
   visiteur vide son navigateur ou navigue en navigation privée.
   ========================================================================== */
(function (global) {
  'use strict';

  var CLE = 'drysnake-chat-memoire';
  var EXPIRATION = 120 * 24 * 60 * 60 * 1000;  /* 120 jours */
  var NOUVELLE_VISITE = 30 * 60 * 1000;        /* 30 min d'inactivité = nouvelle visite */
  var MAX_SUJETS = 3;

  function lire() {
    try {
      var brut = localStorage.getItem(CLE);
      if (!brut) return null;
      var d = JSON.parse(brut);
      if (!d || d.v !== 1 || typeof d.t !== 'number') return null;
      if (Date.now() - d.t > EXPIRATION) { oublier(); return null; }
      if (!Array.isArray(d.s)) d.s = [];
      return d;
    } catch (e) { return null; }
  }

  function ecrire(d) {
    try { localStorage.setItem(CLE, JSON.stringify(d)); } catch (e) {}
  }

  function oublier() {
    try { localStorage.removeItem(CLE); } catch (e) {}
  }

  /* Photo de la mémoire AVANT que la visite en cours ne la modifie.
     C'est cette photo qui sert à décider de l'accueil. */
  var avant = lire();

  /* Est-ce quelqu'un qui revient ? Oui s'il a déjà ouvert le chat lors d'une
     visite précédente (au moins 30 min avant), et pas plus vieux que 120 jours. */
  function deRetour() {
    return !!(avant && avant.n > 0 && (Date.now() - avant.t) > NOUVELLE_VISITE);
  }

  /* Le sujet de la dernière fois, s'il y en a un. */
  function dernierSujet() {
    return (avant && avant.s && avant.s[0]) || null;
  }

  function nombreDeVisites() {
    return (avant && avant.n) || 0;
  }

  /* À appeler une seule fois, quand le visiteur ouvre le chat. */
  var visiteNotee = false;
  function noterVisite() {
    if (visiteNotee) return;
    visiteNotee = true;
    var d = lire() || { v: 1, n: 0, t: Date.now(), s: [] };
    if (!avant || (Date.now() - d.t) > NOUVELLE_VISITE || !avant.n) d.n = (d.n || 0) + 1;
    d.v = 1;
    d.t = Date.now();
    ecrire(d);
  }

  /* À appeler chaque fois qu'une réponse de la base est servie.
     `id` est un identifiant de notre base (ex. « prix-groupe »), rien d'autre. */
  function noterSujet(id) {
    if (!id || typeof id !== 'string') return;
    if (!/^[a-z0-9-]{1,40}$/.test(id)) return;  /* garde-fou : jamais de texte libre */
    var d = lire() || { v: 1, n: 1, t: Date.now(), s: [] };
    d.s = [id].concat(d.s.filter(function (x) { return x !== id; })).slice(0, MAX_SUJETS);
    d.v = 1;
    d.t = Date.now();
    ecrire(d);
  }

  global.MemoireChat = {
    deRetour: deRetour,
    dernierSujet: dernierSujet,
    nombreDeVisites: nombreDeVisites,
    noterVisite: noterVisite,
    noterSujet: noterSujet,
    oublier: oublier
  };
})(typeof window !== 'undefined' ? window : globalThis);


/* ---------- ia.js ---------- */
/* ============================================================================
   Réponse de secours par IA
   ----------------------------------------------------------------------------
   Appelée UNIQUEMENT quand le moteur habituel ne trouve rien. Le moteur règle
   la grande majorité des questions tout seul, instantanément et gratuitement ;
   cette porte de sortie sert aux questions tordues ou combinées.

   Rien ne part d'ici sauf la question elle-même. La clé API n'est pas dans
   cette page : elle vit sur le serveur Supabase, hors de portée.

   Si l'IA ne répond pas — crédits épuisés, panne, plafond atteint, ou
   simplement parce qu'elle ne sait pas — le chatbot reprend son message
   habituel. Le visiteur ne voit jamais d'erreur.
   ========================================================================== */
(function (global) {
  'use strict';

  var CFG = {
    url: 'https://cischkjzmrnlmzseglqv.supabase.co/functions/v1/chatbot-ia',
    cle: 'sb_publishable_xVhLmK173WJ7Z5t4VEQtoQ_FqTHaS5e',
    site: 'drysnake',
    /* Au-delà, on n'attend plus : mieux vaut le message habituel tout de suite
       qu'un client qui fixe trois petits points pendant dix secondes. */
    delaiMax: 9000
  };

  var perso = global.IA_CONFIG || {};
  for (var k in perso) { if (Object.prototype.hasOwnProperty.call(perso, k)) CFG[k] = perso[k]; }


  /* callback(texte) — texte est une chaîne, ou null si pas de réponse. */
  function demander(question, langue, callback) {
    var repondu = false;
    function fini(texte) {
      if (repondu) return;
      repondu = true;
      callback(texte || null);
    }

    var minuterie = setTimeout(function () { fini(null); }, CFG.delaiMax);

    try {
      fetch(CFG.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': CFG.cle,
          'Authorization': 'Bearer ' + CFG.cle
        },
        body: JSON.stringify({
          site: CFG.site,
          langue: langue,
          question: String(question || '').slice(0, 400),
          contexte: ''
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          clearTimeout(minuterie);
          fini(d && d.repondu && d.reponse ? d.reponse : null);
        })
        .catch(function () { clearTimeout(minuterie); fini(null); });
    } catch (e) {
      clearTimeout(minuterie);
      fini(null);
    }
  }

  global.SecoursIA = { demander: demander, config: CFG };
})(typeof window !== 'undefined' ? window : globalThis);


/* ---------- drysnake-engine.js ---------- */
/* ============================================================================
   DRYSNAKE — Moteur de recherche du chatbot
   ----------------------------------------------------------------------------
   Compare la question du client aux entrées de DRYSNAKE_KB.
   Aucune dépendance, aucun appel réseau : tout se passe dans le navigateur.
   ========================================================================== */
(function (global) {
  'use strict';

  var KB = global.DRYSNAKE_KB;
  if (!KB) { console.warn('[Drysnake] drysnake-kb.js doit être chargé avant le moteur.'); return; }

  /* ---------------------------------------------------------------- texte */

  function deaccent(s) {
    return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
  }

  function normalize(s) {
    return deaccent(String(s || '').toLowerCase())
      .replace(/['’`]/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var SYN = {};
  Object.keys(KB.synonyms || {}).forEach(function (canon) {
    SYN[normalize(canon)] = canon;
    (KB.synonyms[canon] || []).forEach(function (v) { SYN[normalize(v)] = canon; });
  });

  var STOP = {};
  (KB.stopwords || []).forEach(function (w) { STOP[normalize(w)] = 1; });

  function stem(w) {
    if (w.length > 4 && /(aux|eaux)$/.test(w)) return w.replace(/(aux|eaux)$/, 'al');
    if (w.length > 3 && /(s|x)$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function tokenize(text) {
    var raw = normalize(text).split(' ');
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var w = raw[i];
      if (!w || w.length < 2) continue;
      // un mot explicitement listé dans les synonymes l'emporte sur la liste
      // des mots ignorés (« car » = voiture en anglais, « pour » en français…)
      var canon = SYN[w] || SYN[stem(w)];
      if (!canon) {
        if (STOP[w]) continue;
        canon = stem(w);
        if (STOP[canon]) continue;
      }
      out.push(canon);
    }
    return out;
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > 2) return 3;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      for (j = 0; j <= b.length; j++) prev[j] = cur[j];
    }
    return prev[b.length];
  }

  /* ---------------------------------------------------------------- index */

  var DOCS = [], IDF = {}, N = 0;

  function addTokens(map, tokens, weight) {
    tokens.forEach(function (t) { if (!map[t] || map[t] < weight) map[t] = weight; });
  }

  function buildIndex() {
    DOCS = []; IDF = {};
    /* dfTopic : nombre d'entrées où le mot est un mot-clé ou apparaît dans une
       question type. dfAll : idem mais en comptant aussi le texte des réponses.
       On calcule la rareté sur dfTopic, sinon un mot comme « livraison », cité
       dans vingt réponses, finirait par ne plus rien vouloir dire. */
    var dfTopic = {}, df = {};
    KB.entries.forEach(function (entry) {
      var weights = {}, parts = [];
      addTokens(weights, tokenize((entry.tags || []).join(' ')), 3);
      parts.push((entry.tags || []).join(' '));
      ['fr', 'en'].forEach(function (lg) {
        ((entry.q && entry.q[lg]) || []).forEach(function (q) {
          addTokens(weights, tokenize(q), 1.6);
          parts.push(q);
        });
      });
      ['fr', 'en'].forEach(function (lg) {
        addTokens(weights, tokenize((entry.a && entry.a[lg]) || ''), 0.35);
      });
      DOCS.push({
        entry: entry,
        weights: weights,
        keys: Object.keys(weights),
        text: ' ' + tokenize(parts.join(' . ')).join(' ') + ' '
      });
      Object.keys(weights).forEach(function (t) {
        df[t] = (df[t] || 0) + 1;
        if (weights[t] >= 1.6) dfTopic[t] = (dfTopic[t] || 0) + 1;
      });
    });
    N = DOCS.length;
    Object.keys(df).forEach(function (t) { IDF[t] = Math.log(1 + N / (dfTopic[t] || df[t])); });
  }

  function idf(t) { return IDF[t] !== undefined ? IDF[t] : 0; }
  function known(t) { return IDF[t] !== undefined; }

  /* Poids donné dans le dénominateur à un mot que la base ne connaît pas :
     il compte comme un indice manquant, sans écraser le reste. */
  var UNKNOWN_PENALTY = 1.5;

  /* Un mot est un « indice fort » quand il est à la fois précis (présent dans
     peu d'entrées) et retrouvé parmi les mots-clés de l'entrée. Les mots des
     questions types ne comptent pas : elles contiennent du remplissage
     (« ça vaut la peine », « est-ce que ça fait ») qui ferait de faux signaux. */
  var STRONG_IDF = 1.7;

  function scoreDoc(doc, qTokens, denom) {
    var num = 0, strong = false, i, k;
    for (i = 0; i < qTokens.length; i++) {
      var t = qTokens[i];
      var w = doc.weights[t];
      if (w !== undefined) {
        num += Math.min(w, 3) / 3 * idf(t);
        if (w >= 3 && idf(t) >= STRONG_IDF) strong = true;
      } else if (t.length >= 5) {
        // tolérance aux fautes de frappe (« ventilatuer », « garentie »…)
        var best = null, bestD = 99;
        for (k = 0; k < doc.keys.length; k++) {
          var key = doc.keys[k], d = levenshtein(t, key);
          if (d < bestD || (d === bestD && doc.weights[key] > doc.weights[best])) { bestD = d; best = key; }
        }
        if (best && bestD <= (t.length >= 8 ? 2 : 1)) {
          num += Math.min(doc.weights[best], 3) / 3 * idf(best) * 0.65;
        }
      }
    }
    var score = denom > 0 ? num / denom : 0;
    // bonus : deux mots consécutifs retrouvés dans le même ordre
    var bonus = 0;
    for (var b = 0; b < qTokens.length - 1; b++) {
      if (doc.text.indexOf(' ' + qTokens[b] + ' ' + qTokens[b + 1] + ' ') !== -1) bonus += 0.06;
    }
    return { score: score + Math.min(bonus, 0.18), strong: strong };
  }

  /* Deux barres à franchir pour qu'une réponse soit servie :
     - MIN_SCORE : la question colle nettement à l'entrée ;
     - MIN_SCORE_STRONG : la question est plus bavarde (« bonjour, j'aimerais
       savoir si… »), donc le score est dilué, mais un mot-clé précis de
       l'entrée est bel et bien présent.
     En dessous, le bot dit qu'il ne sait pas plutôt que de deviner. */
  var MIN_SCORE = 0.36;
  var MIN_SCORE_STRONG = 0.28;

  function accepts(r) {
    return !!r && (r.score >= MIN_SCORE || (r.strong && r.score >= MIN_SCORE_STRONG));
  }

  function search(text) {
    var all = tokenize(text);
    if (!all.length) return [];
    // un même mot ne compte qu'une fois
    var qTokens = [], seen = {};
    for (var j = 0; j < all.length; j++) { if (!seen[all[j]]) { seen[all[j]] = 1; qTokens.push(all[j]); } }

    var denom = 0;
    for (var q = 0; q < qTokens.length; q++) denom += known(qTokens[q]) ? idf(qTokens[q]) : UNKNOWN_PENALTY;

    var res = [];
    for (var i = 0; i < DOCS.length; i++) {
      var s = scoreDoc(DOCS[i], qTokens, denom);
      if (s.score > 0.02) res.push({ entry: DOCS[i].entry, score: s.score, strong: s.strong });
    }
    res.sort(function (a, b) { return b.score - a.score; });
    return res;
  }

  /* --------------------------------------------------------------- langue */

  var FR_HINT = '\\b(le|la|les|un|une|des|est|ce|quoi|comment|combien|pourquoi|quel|quelle|puis|je|mon|ma|mes|vous|votre|avec|pour|sac|garantie|livraison|prix|taille|ventilateur|cartouche|retour|remboursement|merci|bonjour|salut|allo|ou|dans|sur|mais|aussi|ete|etes)\\b';
  var EN_HINT = '\\b(the|is|are|what|how|why|which|can|do|does|i|my|your|with|for|bag|warranty|shipping|price|size|fan|cartridge|return|refund|thanks|hello|hi|where|when|and|not|you)\\b';

  function detectLang(text) {
    var t = ' ' + normalize(text) + ' ';
    var fr = (t.match(new RegExp(FR_HINT, 'g')) || []).length;
    var en = (t.match(new RegExp(EN_HINT, 'g')) || []).length;
    if (/[àâçéèêëîïôûùüœ]/i.test(text)) fr += 2;
    if (fr > en) return 'fr';
    if (en > fr) return 'en';
    return null;
  }

  /* ----------------------------------------------------------------- rendu */

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Sur drysnake.com les liens restent relatifs : même onglet, panier conservé.
     Ailleurs (page d'essai locale, autre domaine) ils pointent vers la boutique. */
  function storeUrl(path, lang) {
    if (/^https?:/.test(path)) return path;
    var onStore = typeof location !== 'undefined' && /(^|\.)drysnake\.com$/.test(location.hostname || '');
    return (onStore ? '' : 'https://drysnake.com') + (lang === 'en' ? '' : '/fr') + path;
  }

  function render(text, lang) {
    var lines = String(text).split('\n'), html = '', inList = false;
    lines.forEach(function (line) {
      var isItem = /^\s*-\s+/.test(line);
      if (isItem && !inList) { html += '<ul>'; inList = true; }
      if (!isItem && inList) { html += '</ul>'; inList = false; }
      var content = escapeHtml(line.replace(/^\s*-\s+/, ''))
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, function (m, label, url) {
          var href = storeUrl(url, lang);
          var ext = /^https?:/.test(href) ? ' target="_blank" rel="noopener"' : '';
          return '<a href="' + escapeHtml(href) + '"' + ext + '>' + label + '</a>';
        })
        .replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, '<a href="mailto:$1">$1</a>');
      html += isItem ? '<li>' + content + '</li>' : '<p>' + content + '</p>';
    });
    if (inList) html += '</ul>';
    return html;
  }

  buildIndex();

  global.DrysnakeEngine = {
    normalize: normalize,
    tokenize: tokenize,
    search: search,
    detectLang: detectLang,
    render: render,
    escapeHtml: escapeHtml,
    storeUrl: storeUrl,
    rebuild: buildIndex,
    accepts: accepts,
    MIN_SCORE: MIN_SCORE,
    MIN_SCORE_STRONG: MIN_SCORE_STRONG,
    entries: KB.entries
  };
})(typeof window !== 'undefined' ? window : globalThis);


/* ---------- drysnake-widget.js ---------- */
/* ============================================================================
   DRYSNAKE — Widget de clavardage (bulle en bas à droite de chaque page)
   ----------------------------------------------------------------------------
   Aucune dépendance, aucun serveur, aucun frais récurrent.
   Se charge après drysnake-kb.js et drysnake-engine.js.

   Réglages possibles AVANT le chargement du script :
     window.DRYSNAKE_CHAT_CONFIG = {
       lang: null,                      // 'fr', 'en', ou null = langue de la page
       email: 'info@drysnake.com',      // adresse de repli
       accent: '#c60800',               // couleur de la bulle
       position: 'right',               // 'right' ou 'left'
       logEndpoint: null                // URL facultative pour journaliser
     };                                 // les questions restées sans réponse
   ========================================================================== */
(function () {
  'use strict';

  if (window.__DRYSNAKE_CHAT_LOADED__) return;
  window.__DRYSNAKE_CHAT_LOADED__ = true;

  var KB = window.DRYSNAKE_KB;
  var E = window.DrysnakeEngine;
  if (!KB || !E) { console.warn('[Drysnake chat] base ou moteur manquant.'); return; }

  var CFG = {
    lang: null, email: 'info@drysnake.com', accent: '#c60800',
    position: 'right', logEndpoint: null
  };
  var user = window.DRYSNAKE_CHAT_CONFIG || {};
  for (var k in user) { if (Object.prototype.hasOwnProperty.call(user, k)) CFG[k] = user[k]; }

  /* =========================================================================
     TEXTES DE L'INTERFACE
     ========================================================================= */

  /* Ton parlé, au « nous » — pas de prénom inventé : c'est l'équipe Drysnake
     qui parle. Si un client demande franchement si c'est une vraie personne,
     la réponse est honnête (voir 'robot'). */
  var T = {
    fr: {
      title: 'Drysnake',
      subtitle: 'On vous répond tout de suite',
      open: 'Poser une question à Drysnake',
      close: 'Fermer',
      placeholder: 'Écrivez-nous…',
      send: 'Envoyer',
      greeting: 'Bonjour ! Ici l\'aide Drysnake.\nGrandeur du sac, temps de séchage, livraison, garantie, ventilateur qui fait des siennes — demandez, on a la réponse.',
      suggestTitle: 'Ce qu\'on nous demande le plus',
      near: 'Ça vous intéresse peut-être aussi',
      nothing: 'Ah, celle-là on ne l\'a pas — et on préfère vous le dire que vous inventer une réponse.\nÉcrivez à **{email}** avec votre question (et votre numéro de commande s\'il y a lieu) : Cédrick répond lui-même, en général en quelques heures.',
      nothingAlt: 'Peut-être une de ces réponses',
      thanks: 'Ça nous fait plaisir ! Revenez nous voir si autre chose vous chicote.',
      hello: 'Bonjour ! Qu\'est-ce qu\'on peut faire pour vous ?',
      human: 'Bien sûr. Écrivez à **{email}** — c\'est Cédrick qui répond, en personne, en général en quelques heures les jours ouvrables.\nVous pouvez aussi passer par le [formulaire de contact](/pages/contact).',
      robot: 'Bonne question, et on ne vous contera pas d\'histoire : je suis une aide automatisée. Je connais les réponses par cœur, mais je ne suis pas une vraie personne.\nPour parler à quelqu\'un pour vrai, écrivez à **{email}** — Cédrick répond lui-même.',
      order: 'Je n\'ai pas accès aux commandes d\'ici, désolé.\nPour tout ce qui touche une commande précise — suivi, changement, retour — écrivez à **{email}** avec votre numéro de commande. C\'est la voie la plus rapide.',
      launcher: 'Une question ?',
      teaserTitle: '👋 Une question ?',
      teaserText: 'Grandeur, livraison, garantie, séchage… demandez, on répond tout de suite.',
      mail: '✉️ Écrire à Drysnake',
      disclaimer: 'Aide automatisée. Pour parler à quelqu\'un : info@drysnake.com',
      greetingBack: 'Rebonjour ! 👋 Ravis de vous revoir.\nQu\'est-ce qu\'on peut faire pour vous aujourd\'hui ?',
      backTopic: 'La dernière fois, on parlait de ça',
      teaserTitleBack: '👋 Rebonjour !',
      teaserTextBack: 'Une autre question ? On est encore là.'
    },
    en: {
      title: 'Drysnake',
      subtitle: 'We answer right away',
      open: 'Ask Drysnake a question',
      close: 'Close',
      placeholder: 'Write to us…',
      send: 'Send',
      greeting: 'Hi! This is Drysnake help.\nBag sizing, drying time, shipping, warranty, a fan acting up — ask away, we\'ve got the answer.',
      suggestTitle: 'What we get asked most',
      near: 'You might also want',
      nothing: 'Ah, that one we don\'t have — and we\'d rather tell you than make something up.\nEmail **{email}** with your question (and your order number if relevant): Cédrick answers personally, usually within a few hours.',
      nothingAlt: 'Maybe one of these',
      thanks: 'Our pleasure! Come back anytime something else comes up.',
      hello: 'Hi there! What can we do for you?',
      human: 'Of course. Email **{email}** — that\'s Cédrick answering in person, usually within a few hours on business days.\nYou can also use the [contact form](/pages/contact).',
      robot: 'Fair question, and we won\'t spin you a story: I\'m automated help. I know the answers by heart, but I\'m not a real person.\nTo talk to someone for real, email **{email}** — Cédrick answers himself.',
      order: 'I don\'t have access to orders from here, sorry.\nFor anything tied to a specific order — tracking, changes, returns — email **{email}** with your order number. That\'s the fastest route.',
      launcher: 'Questions?',
      teaserTitle: '👋 Have a question?',
      teaserText: 'Sizing, shipping, warranty, drying time… ask away, we answer right away.',
      mail: '✉️ Email Drysnake',
      disclaimer: 'Automated help. To reach a person: info@drysnake.com',
      greetingBack: 'Welcome back! 👋 Good to see you again.\nWhat can we do for you today?',
      backTopic: 'Last time we were talking about',
      teaserTitleBack: '👋 Welcome back!',
      teaserTextBack: 'Another question? We\'re still here.'
    }
  };

  /* La boutique Shopify pose <html lang="fr"> sur les pages françaises et
     <html lang="en"> sur les anglaises : c'est le signal le plus fiable.
     En repli, le français vit sous /fr et l'anglais à la racine. */
  function pageLang() {
    if (CFG.lang) return CFG.lang === 'en' ? 'en' : 'fr';
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (l.indexOf('en') === 0) return 'en';
    if (l.indexOf('fr') === 0) return 'fr';
    return /^\/fr(\/|$)/.test(location.pathname) ? 'fr' : 'en';
  }

  var lang = pageLang();
  var langueChoisieParLeVisiteur = false;
  function t(key) { return T[lang][key].replace('{email}', CFG.email); }

  /* =========================================================================
     STRUCTURE (isolée dans un shadow DOM : le thème de la boutique ne peut
     ni déformer le widget, ni être déformé par lui)
     ========================================================================= */

  var host = document.createElement('div');
  host.id = 'drysnake-chat';
  var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
  var side = CFG.position === 'left' ? 'left' : 'right';

  var CSS = [
    ':host, * { box-sizing: border-box; }',
    '.wrap { position: fixed; bottom: 20px; ' + side + ': 20px; z-index: 2147483000;',
    '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }',
    /* Bouton allonge avec libelle : une pastille ronde seule n'indique pas
       au visiteur a quoi elle sert. Une fois ouvert, il redevient un rond. */
    '.bubble { position: relative; height: 58px; padding: 0 22px 0 18px; gap: 11px; border-radius: 999px; border: 0; cursor: pointer;',
    '  background: ' + CFG.accent + '; color: #fff; box-shadow: 0 6px 24px rgba(0,0,0,.28);',
    '  display: flex; align-items: center; justify-content: center; transition: transform .18s ease; }',
    '.bubble:hover { transform: scale(1.04); }',
    '.bubble:focus-visible { outline: 3px solid #111; outline-offset: 3px; }',
    '.bubble svg { width: 26px; height: 26px; display: block; flex: none; }',
    '.bubble .label { font-size: 15.5px; font-weight: 700; letter-spacing: .2px; white-space: nowrap; }',
    '.bubble .x { display: none; }',
    '.wrap.open .bubble { width: 58px; padding: 0; justify-content: center; }',
    '.wrap.open .bubble .chat, .wrap.open .bubble .label { display: none; }',
    '.wrap.open .bubble .x { display: block; }',

    '.teaser { position: absolute; bottom: calc(100% + 26px); ' + side + ': 0; width: 250px; background: #fff; color: #1c1c1c;',
    '  border-radius: 14px; padding: 13px 30px 13px 14px; font-size: 13.5px; line-height: 1.45;',
    '  box-shadow: 0 6px 18px rgba(0,0,0,.18); display: none; text-align: left; }',
    '.teaser.on { display: block; animation: dsnpop .28s ease; }',
    '.wrap.open .teaser { display: none; }',
    '.teaser b { display: block; margin-bottom: 2px; }',
    '.teaser .kill { position: absolute; top: 6px; ' + side + ': 8px; border: 0; background: transparent;',
    '  color: #9aa0a6; font-size: 15px; cursor: pointer; line-height: 1; padding: 3px; font-family: inherit; }',
    '.teaser .kill:hover { color: #1c1c1c; }',
    '@keyframes dsnpop { from { opacity: 0; transform: translateY(8px) } to { opacity: 1; transform: translateY(0) } }',
    '.dot { position: absolute; top: 1px; ' + side + ': 1px; width: 13px; height: 13px; border-radius: 50%;',
    '  background: #2ecc71; border: 2px solid #fff; }',
    '.wrap.open .dot, .wrap.seen .dot { display: none; }',

    '.panel { position: absolute; bottom: 76px; ' + side + ': 0; width: 380px; max-width: calc(100vw - 32px);',
    '  height: 580px; max-height: calc(100vh - 120px); background: #fff; border-radius: 16px; overflow: hidden;',
    '  box-shadow: 0 18px 60px rgba(0,0,0,.30); display: none; flex-direction: column;',
    '  opacity: 0; transform: translateY(12px); transition: opacity .18s ease, transform .18s ease; }',
    '.wrap.open .panel { display: flex; opacity: 1; transform: translateY(0); }',

    '.head { background: #111; color: #fff; padding: 13px 14px; display: flex; align-items: center; gap: 11px; }',
    '.head .logo { width: 34px; height: 34px; border-radius: 50%; background: ' + CFG.accent + ';',
    '  display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 15px; flex: none; }',
    '.head .who { flex: 1; min-width: 0; }',
    '.head .who b { display: block; font-size: 14.5px; letter-spacing: .3px; }',
    '.head .who span { display: block; font-size: 11.5px; opacity: .72; margin-top: 2px; }',
    '.head button { background: transparent; border: 0; color: #fff; cursor: pointer; padding: 5px 7px;',
    '  border-radius: 6px; font-size: 12px; opacity: .85; font-family: inherit; }',
    '.head button:hover { opacity: 1; background: rgba(255,255,255,.14); }',
    '.head .lang { font-weight: 700; letter-spacing: .5px; border: 1px solid rgba(255,255,255,.35); }',

    '.log { flex: 1; overflow-y: auto; padding: 15px; background: #f6f7f8; }',
    '.msg { display: flex; margin-bottom: 11px; }',
    '.msg .b { max-width: 85%; padding: 10px 13px; border-radius: 14px; font-size: 14px; line-height: 1.5;',
    '  background: #fff; color: #1c1c1c; box-shadow: 0 1px 2px rgba(0,0,0,.08);',
    '  border-bottom-left-radius: 4px; overflow-wrap: anywhere; }',
    '.msg.me { justify-content: flex-end; }',
    '.msg.me .b { background: ' + CFG.accent + '; color: #fff; border-bottom-left-radius: 14px; border-bottom-right-radius: 4px; }',
    '.msg .b p { margin: 0 0 7px; }',
    '.msg .b p:last-child { margin-bottom: 0; }',
    '.msg .b ul { margin: 4px 0 8px; padding-left: 18px; }',
    '.msg .b li { margin-bottom: 3px; }',
    '.msg .b a { color: ' + CFG.accent + '; font-weight: 600; }',
    '.msg.me .b a { color: #fff; text-decoration: underline; }',

    '.chips { display: flex; flex-wrap: wrap; gap: 6px; margin: 0 0 13px; }',
    '.chips .t { width: 100%; font-size: 11px; text-transform: uppercase; letter-spacing: .7px;',
    '  color: #8a8a8a; margin-bottom: 2px; }',
    '.chip { background: #fff; border: 1px solid #dcdfe3; color: #1c1c1c; border-radius: 999px;',
    '  padding: 7px 12px; font-size: 12.5px; cursor: pointer; text-align: left; line-height: 1.3;',
    '  font-family: inherit; text-decoration: none; display: inline-block; }',
    '.chip:hover { border-color: ' + CFG.accent + '; color: ' + CFG.accent + '; }',

    '.typing { display: flex; gap: 4px; align-items: center; padding: 13px 14px; }',
    '.typing i { width: 7px; height: 7px; border-radius: 50%; background: #b9bcc0; animation: dsnb 1.1s infinite; }',
    '.typing i:nth-child(2) { animation-delay: .15s; }',
    '.typing i:nth-child(3) { animation-delay: .3s; }',
    '@keyframes dsnb { 0%,60%,100% { transform: translateY(0); opacity:.5 } 30% { transform: translateY(-5px); opacity:1 } }',

    '.foot { border-top: 1px solid #e6e8ea; background: #fff; padding: 10px 12px; }',
    '.row { display: flex; gap: 8px; align-items: flex-end; }',
    'textarea { flex: 1; resize: none; border: 1px solid #dcdfe3; border-radius: 12px; padding: 10px 12px;',
    '  font-family: inherit; font-size: 14px; line-height: 1.4; max-height: 96px; height: 40px; color: #1c1c1c; background: #fff; }',
    'textarea:focus { outline: none; border-color: ' + CFG.accent + '; }',
    '.send { border: 0; background: ' + CFG.accent + '; color: #fff; width: 40px; height: 40px; border-radius: 12px;',
    '  cursor: pointer; flex: none; display: flex; align-items: center; justify-content: center; }',
    '.send svg { width: 18px; height: 18px; }',
    '.legal { font-size: 10.5px; color: #9aa0a6; text-align: center; margin-top: 7px; }',

    '@media (max-width: 480px) {',
    '  .wrap { bottom: 14px; ' + side + ': 14px; }',
    '  .panel { width: calc(100vw - 24px); height: calc(100vh - 110px); bottom: 72px; ' + side + ': -4px; }',
    '  .teaser { width: min(250px, calc(100vw - 40px)); }',
    '  .bubble { height: 54px; padding: 0 18px 0 15px; }',
    '  .bubble .label { font-size: 14.5px; }',
    '  .wrap.open .bubble { width: 54px; padding: 0; }',
    '}'
  ].join('\n');

  root.innerHTML =
    '<style>' + CSS + '</style>' +
    '<div class="wrap">' +
      '<div class="panel" role="dialog" aria-label="' + t('title') + '">' +
        '<div class="head">' +
          '<div class="logo">D</div>' +
          '<div class="who"><b class="h-title"></b><span class="h-sub"></span></div>' +
          '<button class="lang" type="button" title="Français / English"></button>' +
          '<button class="close" type="button" aria-label="' + t('close') + '">&#10005;</button>' +
        '</div>' +
        '<div class="log" aria-live="polite"></div>' +
        '<div class="foot">' +
          '<div class="row">' +
            '<textarea rows="1"></textarea>' +
            '<button class="send" type="button" aria-label="' + t('send') + '">' +
              '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="legal"></div>' +
        '</div>' +
      '</div>' +
      '<div class="teaser">' +
        '<button class="kill" type="button" aria-label="' + t('close') + '">&#10005;</button>' +
        '<b class="teaser-title"></b><span class="teaser-text"></span>' +
      '</div>' +
      '<button class="bubble" type="button">' +
        '<span class="dot"></span>' +
        '<svg class="chat" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3C6.9 3 2.8 6.4 2.8 10.6c0 2.4 1.3 4.5 3.4 5.9-.1 1-.6 2.4-1.6 3.4 0 0 2.6-.3 4.6-1.9.9.2 1.8.3 2.8.3 5.1 0 9.2-3.4 9.2-7.7S17.1 3 12 3z"/></svg>' +
        '<svg class="x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '<span class="label"></span>' +
      '</button>' +
    '</div>';

  (document.body || document.documentElement).appendChild(host);

  var $wrap  = root.querySelector('.wrap');
  var $panel = root.querySelector('.panel');
  var $log   = root.querySelector('.log');
  var $ta    = root.querySelector('textarea');
  var $send  = root.querySelector('.send');
  var $close = root.querySelector('.close');
  var $bub   = root.querySelector('.bubble');
  var $lang  = root.querySelector('.lang');

  function applyLangLabels() {
    root.querySelector('.h-title').textContent = t('title');
    root.querySelector('.h-sub').textContent = t('subtitle');
    root.querySelector('.legal').textContent = t('disclaimer');
    root.querySelector('.bubble .label').textContent = t('launcher');
    var retour = !!(window.MemoireChat && window.MemoireChat.deRetour());
    root.querySelector('.teaser-title').textContent = t(retour ? 'teaserTitleBack' : 'teaserTitle');
    root.querySelector('.teaser-text').textContent = t(retour ? 'teaserTextBack' : 'teaserText');
    $ta.setAttribute('placeholder', t('placeholder'));
    $lang.textContent = lang === 'fr' ? 'EN' : 'FR';
    $panel.setAttribute('aria-label', t('title'));
    $bub.setAttribute('aria-label', t('open'));
  }

  /* =========================================================================
     MESSAGES
     ========================================================================= */

  var history = [];

  function scrollDown() { $log.scrollTop = $log.scrollHeight; }

  function bubbleMsg(html, mine) {
    var d = document.createElement('div');
    d.className = 'msg' + (mine ? ' me' : '');
    d.innerHTML = '<div class="b">' + html + '</div>';
    $log.appendChild(d);
    scrollDown();
    return d;
  }

  function say(text, silent) {
    bubbleMsg(E.render(text, lang), false);
    if (!silent) history.push({ who: 'bot', text: text });
  }

  function me(text) {
    bubbleMsg('<p>' + E.escapeHtml(text) + '</p>', true);
    history.push({ who: 'user', text: text });
  }

  /* items : soit des chaînes (la question est relancée dans le moteur),
     soit { label, entry } (on affiche directement la réponse de cette entrée). */
  function chips(title, items) {
    var d = document.createElement('div');
    d.className = 'chips';
    if (title) {
      var h = document.createElement('div');
      h.className = 't'; h.textContent = title;
      d.appendChild(h);
    }
    items.forEach(function (item) {
      var label = typeof item === 'string' ? item : item.label;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'chip'; b.textContent = label;
      b.addEventListener('click', function () {
        d.remove();
        if (typeof item === 'string') ask(label, true);
        else askEntry(label, item.entry);
      });
      d.appendChild(b);
    });
    $log.appendChild(d);
    scrollDown();
  }

  function mailChip(question) {
    var subject = lang === 'fr' ? 'Question depuis le site Drysnake' : 'Question from the Drysnake website';
    var body = (lang === 'fr' ? 'Bonjour,\n\nMa question : ' : 'Hello,\n\nMy question: ') + (question || '');
    var d = document.createElement('div');
    d.className = 'chips';
    var a = document.createElement('a');
    a.className = 'chip';
    a.href = 'mailto:' + CFG.email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    a.textContent = t('mail');
    d.appendChild(a);
    $log.appendChild(d);
    scrollDown();
  }

  function typing() {
    var d = document.createElement('div');
    d.className = 'msg';
    d.innerHTML = '<div class="b typing"><i></i><i></i><i></i></div>';
    $log.appendChild(d);
    scrollDown();
    return d;
  }

  /* =========================================================================
     LOGIQUE DE RÉPONSE
     ========================================================================= */

  var RE_HELLO  = /^(bonjour|bonsoir|salut|allo|hello|hi|hey|yo)[\s!.,]*$/i;
  var RE_THANKS = /(merci|thanks|thank you|thx|parfait|nickel|great|perfect)/i;
  /* Le client demande la NATURE de son interlocuteur (robot ? IA ?).
     À ne pas confondre avec « je veux parler à un humain », qui est une
     demande de contact et se trouve juste en dessous. */
  var RE_ROBOT  = /(\brobot\b|\bchatbot\b|\bbot\b|intelligence artificielle|\bia\b|es[ -]?tu (une |un )?(vrai|vraie)|etes[ -]?vous (une |un )?(vrai|vraie)|vraie personne|real person|are you (a )?real|are you human|is this (a |an )?(human|ai)|talking (to|with) (a |an )?(human|person|machine))/i;
  var RE_HUMAN  = /(parler (a|à) (un|une|quelqu)|un humain|une personne|un agent|repr(e|é)sentant|talk to (a|someone)|speak to (a|someone)|real person|a human|customer service|service (a|à) la client(e|è)le)/i;
  var RE_ORDER  = /(#\s?\d{3,6}|commande\s*(no|n°|num(e|é)ro)?\s*\d{3,6}|order\s*(no|number|#)?\s*\d{3,6})/i;

  function fire(name, data) {
    try {
      document.dispatchEvent(new CustomEvent('drysnake:chat:' + name, { detail: data || {} }));
      if (window.dataLayer && window.dataLayer.push) {
        var payload = { event: 'drysnake_chat_' + name };
        for (var key in (data || {})) payload[key] = data[key];
        window.dataLayer.push(payload);
      }
      /* Mémoire de visite : on retient le sujet (jamais la question tapée),
         pour pouvoir le reproposer si la personne revient un autre jour. */
      if (name === 'answered' && data.entry && window.MemoireChat) {
        window.MemoireChat.noterSujet(data.entry);
      }

      /* Journal des conversations, pour le rapport hebdomadaire */
      if ((name === 'answered' || name === 'unanswered') && window.JournalChat) {
        window.JournalChat.enregistrer({
          question: data.question,
          langue: lang,
          reponseId: data.entry || null,
          repondu: name === 'answered',
          score: typeof data.score === 'number' ? data.score : null,
          texte: data.texte || null
        });
      }
      if (name === 'unanswered' && CFG.logEndpoint && navigator.sendBeacon) {
        navigator.sendBeacon(CFG.logEndpoint, JSON.stringify({
          q: data.question, lang: lang, url: location.href, ts: Date.now()
        }));
      }
    } catch (e) {}
  }

  function decide(question) {
    if (RE_HELLO.test(question.trim())) return { type: 'hello' };
    if (RE_ROBOT.test(question)) return { type: 'robot' };
    if (RE_HUMAN.test(question)) return { type: 'human' };
    if (RE_THANKS.test(question) && E.tokenize(question).length <= 2) return { type: 'thanks' };

    var results = E.search(question);
    var best = results[0];
    var weak = !E.accepts(best);

    // Un numéro de commande sans sujet identifiable : renvoyer vers Cédrick
    // plutôt que d'improviser. Si le message porte aussi sur un sujet connu
    // (« ma commande #3341 : le ventilateur ne marche pas »), on répond au sujet.
    if (weak && RE_ORDER.test(question)) return { type: 'order' };

    if (weak) {
      // On ne propose un sujet voisin que s'il est vraiment voisin ; sinon on
      // remet les questions fréquentes, plus utiles qu'une piste au hasard.
      return { type: 'none', near: results.slice(0, 3).filter(function (r) { return r.score > 0.24; }) };
    }
    return {
      type: 'answer', entry: best.entry, score: best.score,
      near: results.slice(1, 3).filter(function (r) {
        return r.score >= best.score * 0.8 && E.accepts(r);
      })
    };
  }

  function entryLabel(entry) {
    if (entry.title && entry.title[lang]) return entry.title[lang];
    var qs = (entry.q && (entry.q[lang] || entry.q.fr)) || [];
    var label = qs[0] || entry.id;
    return label.charAt(0).toUpperCase() + label.slice(1);
  }

  /* Temps de frappe proportionnel à la longueur de la réponse : une réponse
     courte arrive vite, une longue prend un moment. C'est ce qui donne
     l'impression que quelqu'un écrit, plutôt qu'une fiche qui s'affiche. */
  function texteAttendu(res) {
    if (res.type === 'answer') return (res.entry.a[lang] || res.entry.a.fr || '');
    if (res.type === 'none') return t('nothing');
    if (res.type === 'robot') return t('robot');
    if (res.type === 'human') return t('human');
    if (res.type === 'order') return t('order');
    if (res.type === 'thanks') return t('thanks');
    return t('hello');
  }

  function tempsDeFrappe(texte) {
    var n = (texte || '').length;
    return Math.max(600, Math.min(2400, 450 + n * 9));
  }

  var busy = false;

  /* Réponse directe, sans repasser par le moteur : utilisé par les boutons
     de sujets proches, dont l'entrée exacte est déjà connue. */
  function askEntry(label, entry) {
    if (busy) return;
    me(label);
    busy = true;
    var ind = typing();
    setTimeout(function () {
      ind.remove();
      say(entry.a[lang] || entry.a.fr);
      fire('answered', { question: label, entry: entry.id, score: 1 });
      busy = false;
      save();
      $ta.focus();
    }, tempsDeFrappe(entry.a[lang] || entry.a.fr));
  }

  function servirReponseDuMoteur(question, res) {
    say(res.entry.a[lang] || res.entry.a.fr);
    fire('answered', { question: question, entry: res.entry.id, score: Math.round(res.score * 100) / 100 });
    if (res.near && res.near.length) {
      chips(t('near'), res.near.map(function (r) { return { label: entryLabel(r.entry), entry: r.entry }; }));
    }
  }

  /* Quand demander un second avis a l'IA meme si le moteur a trouve quelque
     chose ?  Uniquement si les DEUX signaux sont la :

       - le moteur est peu sur de lui (score sous SEUIL_SECOND_AVIS), et
       - la question est longue (au moins MOTS_MIN mots).

     C'est la signature d'une question a plusieurs volets — « c'est quoi la
     garantie ET je peux tu le retourner si ca fait pas ? » — ou le moteur
     repond correctement a UN volet et laisse tomber l'autre.

     Les questions courtes gardent la reponse ecrite a la main, meme avec un
     score modeste : elle est meilleure que ce que l'IA reformulerait.
     Sur le banc d'essai, cette regle ne detourne que 4 reponses sur 110. */
  var SEUIL_SECOND_AVIS = 0.50;
  var MOTS_MIN_SECOND_AVIS = 10;

  function compterMots(q) {
    return String(q || '').split(/[\s,;]+/).filter(Boolean).length;
  }

  function meriteUnSecondAvis(question, res) {
    return res.type === 'answer' &&
           typeof res.score === 'number' &&
           res.score < SEUIL_SECOND_AVIS &&
           compterMots(question) >= MOTS_MIN_SECOND_AVIS;
  }

  /* Le message honnete de dernier recours : ni le moteur ni l'IA n'ont trouve.
     On l'avoue, on donne l'adresse courriel, et on propose les sujets voisins. */
  function repondreQuOnNeSaitPas(question, res) {
    say(t('nothing'));
    mailChip(question);
    if (res.near && res.near.length) {
      chips(t('nothingAlt'), res.near.map(function (r) { return { label: entryLabel(r.entry), entry: r.entry }; }));
    } else {
      chips(t('suggestTitle'), KB.suggestions[lang]);
    }
    fire('unanswered', { question: question });
  }

  function ask(question, fromChip) {
    question = String(question || '').trim();
    if (!question || busy) return;

    var detected = E.detectLang(question);
    if (!fromChip && detected && detected !== lang) { lang = detected; applyLangLabels(); }

    me(question);
    $ta.value = '';
    autosize();
    busy = true;

    var res = decide(question);
    var ind = typing();

    /* Le moteur n'a rien trouve : avant d'abandonner, on tente l'IA de
       secours. L'indicateur « en train d'ecrire » reste affiche pendant
       qu'elle reflechit — c'est justement le moment ou on est cense chercher. */
    if (window.SecoursIA && (res.type === 'none' || meriteUnSecondAvis(question, res))) {
      window.SecoursIA.demander(question, lang, function (texteIA) {
        ind.remove();
        if (texteIA) {
          say(texteIA);
          fire('answered', { question: question, entry: 'ia', score: 1, texte: texteIA });
        } else if (res.type === 'none') {
          repondreQuOnNeSaitPas(question, res);
        } else {
          /* Filet : l'IA n'a rien ajoute, on sert la reponse du moteur. */
          servirReponseDuMoteur(question, res);
        }
        busy = false;
        save();
        $ta.focus();
      });
      return;
    }

    setTimeout(function () {
      ind.remove();
      if (res.type === 'hello') {
        say(t('hello'));
        chips(t('suggestTitle'), KB.suggestions[lang]);
      } else if (res.type === 'thanks') {
        say(t('thanks'));
      } else if (res.type === 'robot') {
        say(t('robot'));
        mailChip(question);
        fire('answered', { question: question, entry: 'question-robot', score: 1 });
      } else if (res.type === 'human') {
        say(t('human'));
        mailChip(question);
      } else if (res.type === 'order') {
        say(t('order'));
        mailChip(question);
      } else if (res.type === 'none') {
        repondreQuOnNeSaitPas(question, res);
      } else {
        servirReponseDuMoteur(question, res);
      }
      busy = false;
      save();
      $ta.focus();
    }, tempsDeFrappe(texteAttendu(res)));
  }

  /* =========================================================================
     ÉTAT ET OUVERTURE
     ========================================================================= */

  function save() {
    try {
      sessionStorage.setItem('drysnake-chat', JSON.stringify({
        lang: lang, manuel: langueChoisieParLeVisiteur, history: history.slice(-40)
      }));
    } catch (e) {}
  }

  function entreeParId(id) {
    if (!id) return null;
    for (var i = 0; i < KB.entries.length; i++) if (KB.entries[i].id === id) return KB.entries[i];
    return null;
  }

  /* Vrai une seule fois : au tout premier accueil de la visite en cours, si le
     visiteur avait déjà ouvert le chat lors d'une visite précédente. On le
     remet à faux ensuite pour que le bouton FR/EN ne redonne pas « Rebonjour ». */
  var accueilDeRetour = !!(window.MemoireChat && window.MemoireChat.deRetour());

  function greet() {
    $log.innerHTML = '';
    if (accueilDeRetour) {
      accueilDeRetour = false;
      say(t('greetingBack'), true);
      var sujet = entreeParId(window.MemoireChat.dernierSujet());
      if (sujet) {
        chips(t('backTopic'), [{ label: entryLabel(sujet), entry: sujet }]);
        return;
      }
    } else {
      say(t('greeting'), true);
    }
    chips(t('suggestTitle'), KB.suggestions[lang]);
  }

  function restore() {
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem('drysnake-chat')); } catch (e) {}
    if (!data || !data.history || !data.history.length) { greet(); return; }
    /* On ne reprend la langue mémorisée que si le visiteur l'a choisie
       lui-même dans le chat. Sinon c'est la langue de la boutique qui
       commande : s'il vient de passer en français, le chat suit. */
    if (data.manuel && data.lang) { lang = data.lang; langueChoisieParLeVisiteur = true; }
    applyLangLabels();
    $log.innerHTML = '';
    say(t(accueilDeRetour ? 'greetingBack' : 'greeting'), true);
    accueilDeRetour = false;
    data.history.forEach(function (m) {
      if (m.who === 'user') bubbleMsg('<p>' + E.escapeHtml(m.text) + '</p>', true);
      else say(m.text, true);
    });
    history = data.history;
    scrollDown();
  }

  var started = false;

  function open() {
    $wrap.classList.add('open', 'seen');
    cacherTeaser();
    if (!started) {
      started = true;
      restore();
      if (window.MemoireChat) window.MemoireChat.noterVisite();
      fire('open');
    }
    setTimeout(function () { $ta.focus(); }, 120);
  }
  function close() { $wrap.classList.remove('open'); $bub.focus(); }

  function autosize() {
    $ta.style.height = 'auto';
    $ta.style.height = Math.min(96, Math.max(40, $ta.scrollHeight)) + 'px';
  }

  $bub.addEventListener('click', function () {
    if ($wrap.classList.contains('open')) close(); else open();
  });
  $close.addEventListener('click', close);
  $send.addEventListener('click', function () { ask($ta.value); });
  $ta.addEventListener('input', autosize);
  $ta.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); ask($ta.value); }
  });
  $lang.addEventListener('click', function () {
    lang = lang === 'fr' ? 'en' : 'fr';
    langueChoisieParLeVisiteur = true;
    applyLangLabels();
    history = [];
    greet();
    save();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $wrap.classList.contains('open')) close();
  });

  /* ------- petite invitation, une seule fois par visite ------- */
  var $teaser = root.querySelector('.teaser');

  function teaserVu() {
    try { return sessionStorage.getItem('drysnake-chat-teaser') === '1'; } catch (e) { return false; }
  }
  function cacherTeaser() {
    $teaser.classList.remove('on');
    try { sessionStorage.setItem('drysnake-chat-teaser', '1'); } catch (e) {}
  }

  $teaser.addEventListener('click', function (e) {
    if (e.target.classList.contains('kill')) { e.stopPropagation(); cacherTeaser(); return; }
    cacherTeaser();
    open();
  });

  if (!teaserVu()) {
    setTimeout(function () {
      if (!$wrap.classList.contains('open') && !teaserVu()) $teaser.classList.add('on');
    }, 5000);
  }

  applyLangLabels();

  /* Pratique pour un bouton « Une question ? » ailleurs sur le site :
     <a href="#" onclick="DrysnakeChat.ask('Quelle grandeur choisir ?'); return false;"> */
  window.DrysnakeChat = {
    open: open,
    close: close,
    ask: function (q) { open(); setTimeout(function () { ask(q, true); }, 220); },
    setLang: function (l) { lang = (l === 'en' ? 'en' : 'fr'); applyLangLabels(); history = []; greet(); },
    version: '1.0.0'
  };
})();